/**
 * @generated SignedSource<<6eae84794eb1a22e884c325cf1acb448>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accounts_select_column = "account_type" | "allocated_views_enabled" | "allow_future_actuals" | "allow_profile_photos" | "alternative_account_id" | "billing_method" | "billing_type" | "business_days" | "copy_started_at" | "copy_status" | "currency" | "default_full_time_minutes" | "id" | "integrations" | "last_copied" | "name" | "rate_type" | "references" | "secondary_person_field" | "subscription" | "subscription_customer" | "subscription_entitlements" | "subscription_type" | "timesheet_lock" | "timesheet_lock_method" | "timesheet_notifications" | "timesheets_enabled" | "timesheets_protected" | "use_week_numbers" | "website" | "%future added value";
export type accounts_select_column_accounts_aggregate_bool_exp_bool_and_arguments_columns = "allocated_views_enabled" | "allow_future_actuals" | "allow_profile_photos" | "timesheet_notifications" | "timesheets_enabled" | "timesheets_protected" | "use_week_numbers" | "%future added value";
export type accounts_select_column_accounts_aggregate_bool_exp_bool_or_arguments_columns = "allocated_views_enabled" | "allow_future_actuals" | "allow_profile_photos" | "timesheet_notifications" | "timesheets_enabled" | "timesheets_protected" | "use_week_numbers" | "%future added value";
export type actuals_select_column = "account_id" | "billable_minutes" | "billable_note" | "created_at" | "date_iso" | "id" | "nonbillable_minutes" | "nonbillable_note" | "origin_data" | "person_id" | "phase_id" | "project_id" | "role_id" | "updated_at" | "workstream_id" | "%future added value";
export type assignments_select_column = "account_id" | "active" | "created_at" | "end_date_iso" | "id" | "is_billable" | "is_template" | "minutes_per_day" | "non_working_day" | "note" | "person_id" | "phase_id" | "project_id" | "role_id" | "start_date_iso" | "updated_at" | "workstream_id" | "%future added value";
export type assignments_select_column_assignments_aggregate_bool_exp_bool_and_arguments_columns = "active" | "is_billable" | "is_template" | "non_working_day" | "%future added value";
export type assignments_select_column_assignments_aggregate_bool_exp_bool_or_arguments_columns = "active" | "is_billable" | "is_template" | "non_working_day" | "%future added value";
export type clients_select_column = "account_id" | "active" | "created_at" | "id" | "image_key" | "name" | "real_client" | "references" | "updated_at" | "website" | "%future added value";
export type clients_select_column_clients_aggregate_bool_exp_bool_and_arguments_columns = "active" | "real_client" | "%future added value";
export type clients_select_column_clients_aggregate_bool_exp_bool_or_arguments_columns = "active" | "real_client" | "%future added value";
export type contracts_select_column = "account_id" | "created_at" | "employment_type" | "end_date_iso" | "id" | "job_title" | "minutes_per_day" | "person_id" | "role_id" | "rostered_days" | "start_date_iso" | "updated_at" | "%future added value";
export type custom_checkbox_types_select_column = "description" | "filterable_in_planner" | "id" | "model" | "name" | "required" | "show_in_planner" | "sort_order" | "%future added value";
export type custom_checkbox_types_select_column_custom_checkbox_types_aggregate_bool_exp_bool_and_arguments_columns = "filterable_in_planner" | "required" | "show_in_planner" | "%future added value";
export type custom_checkbox_types_select_column_custom_checkbox_types_aggregate_bool_exp_bool_or_arguments_columns = "filterable_in_planner" | "required" | "show_in_planner" | "%future added value";
export type custom_checkbox_values_select_column = "custom_checkbox_type_id" | "id" | "model" | "person_id" | "project_id" | "value" | "%future added value";
export type custom_checkbox_values_select_column_custom_checkbox_values_aggregate_bool_exp_bool_and_arguments_columns = "value" | "%future added value";
export type custom_checkbox_values_select_column_custom_checkbox_values_aggregate_bool_exp_bool_or_arguments_columns = "value" | "%future added value";
export type custom_date_types_select_column = "description" | "filterable_in_planner" | "id" | "model" | "name" | "required" | "show_in_planner" | "sort_order" | "%future added value";
export type custom_date_types_select_column_custom_date_types_aggregate_bool_exp_bool_and_arguments_columns = "filterable_in_planner" | "required" | "show_in_planner" | "%future added value";
export type custom_date_types_select_column_custom_date_types_aggregate_bool_exp_bool_or_arguments_columns = "filterable_in_planner" | "required" | "show_in_planner" | "%future added value";
export type custom_date_values_select_column = "custom_date_type_id" | "id" | "model" | "person_id" | "project_id" | "value" | "%future added value";
export type custom_select_options_select_column = "custom_select_type_id" | "id" | "name" | "%future added value";
export type custom_select_types_select_column = "description" | "filterable_in_planner" | "id" | "model" | "name" | "required" | "show_in_planner" | "single_select" | "sort_order" | "%future added value";
export type custom_select_types_select_column_custom_select_types_aggregate_bool_exp_bool_and_arguments_columns = "filterable_in_planner" | "required" | "show_in_planner" | "single_select" | "%future added value";
export type custom_select_types_select_column_custom_select_types_aggregate_bool_exp_bool_or_arguments_columns = "filterable_in_planner" | "required" | "show_in_planner" | "single_select" | "%future added value";
export type custom_select_values_select_column = "custom_select_option_id" | "custom_select_type_id" | "id" | "model" | "person_id" | "project_id" | "%future added value";
export type custom_text_types_select_column = "description" | "filterable_in_planner" | "id" | "model" | "name" | "required" | "show_in_planner" | "sort_order" | "%future added value";
export type custom_text_types_select_column_custom_text_types_aggregate_bool_exp_bool_and_arguments_columns = "filterable_in_planner" | "required" | "show_in_planner" | "%future added value";
export type custom_text_types_select_column_custom_text_types_aggregate_bool_exp_bool_or_arguments_columns = "filterable_in_planner" | "required" | "show_in_planner" | "%future added value";
export type custom_text_values_select_column = "custom_text_type_id" | "id" | "model" | "person_id" | "project_id" | "value" | "%future added value";
export type ext_person_select_column = "account_id" | "active" | "created_at" | "deleted" | "email" | "ext_team_id" | "external_id" | "first_name" | "id" | "image_key" | "integration_id" | "is_placeholder" | "last_name" | "references" | "remote_id" | "sync" | "tags" | "updated_at" | "%future added value";
export type ext_person_select_column_ext_person_aggregate_bool_exp_bool_and_arguments_columns = "active" | "deleted" | "is_placeholder" | "sync" | "%future added value";
export type ext_person_select_column_ext_person_aggregate_bool_exp_bool_or_arguments_columns = "active" | "deleted" | "is_placeholder" | "sync" | "%future added value";
export type ext_project_select_column = "account_id" | "active" | "confirmed" | "created_at" | "deleted" | "emoji" | "expenses_budget" | "external_id" | "id" | "integration_id" | "is_template" | "name" | "pricing_model" | "priority" | "rate_type" | "references" | "remote_id" | "remote_key" | "remote_url" | "sync" | "tags" | "total_budget" | "updated_at" | "%future added value";
export type ext_project_select_column_ext_project_aggregate_bool_exp_bool_and_arguments_columns = "active" | "confirmed" | "deleted" | "is_template" | "sync" | "%future added value";
export type ext_project_select_column_ext_project_aggregate_bool_exp_bool_or_arguments_columns = "active" | "confirmed" | "deleted" | "is_template" | "sync" | "%future added value";
export type holidays_groups_select_column = "account_id" | "country_code" | "country_name" | "created_at" | "id" | "name" | "region_name" | "updated_at" | "%future added value";
export type holidays_select_column = "account_id" | "created_at" | "date" | "holiday_api_uuid" | "holidays_group_id" | "id" | "name" | "observed" | "type" | "updated_at" | "%future added value";
export type invitation_people_managers_select_column = "account_id" | "created_at" | "id" | "invitation_id" | "person_id" | "updated_at" | "%future added value";
export type invitation_project_managers_select_column = "account_id" | "created_at" | "id" | "invitation_id" | "project_id" | "updated_at" | "%future added value";
export type invitations_select_column = "account_id" | "add_all_people_to_projects_permission" | "created_at" | "email" | "expires_at" | "fin_permission" | "from_user_id" | "id" | "manage_account_permission" | "manage_people_permission" | "manage_projects_permission" | "updated_at" | "user_type" | "uuid" | "view_planner_permission" | "%future added value";
export type invitations_select_column_invitations_aggregate_bool_exp_bool_and_arguments_columns = "add_all_people_to_projects_permission" | "manage_account_permission" | "view_planner_permission" | "%future added value";
export type invitations_select_column_invitations_aggregate_bool_exp_bool_or_arguments_columns = "add_all_people_to_projects_permission" | "manage_account_permission" | "view_planner_permission" | "%future added value";
export type milestones_select_column = "account_id" | "created_at" | "date" | "icon" | "id" | "note" | "project_id" | "title" | "updated_at" | "%future added value";
export type notes_select_column = "account_id" | "created_at" | "created_by" | "creator_email" | "id" | "note" | "project_id" | "updated_at" | "user_id" | "%future added value";
export type other_costs_select_column = "account_id" | "charge" | "cost" | "date" | "id" | "name" | "phase_id" | "project_id" | "%future added value";
export type people_managers_select_column = "account_id" | "id" | "person_id" | "user_id" | "%future added value";
export type people_notes_select_column = "created_at" | "created_by" | "creator_email" | "id" | "note" | "person_id" | "updated_at" | "user_id" | "%future added value";
export type people_select_column = "account_id" | "active" | "created_at" | "email" | "first_name" | "id" | "image_key" | "is_placeholder" | "last_name" | "placeholder_count" | "references" | "tags" | "team_id" | "updated_at" | "%future added value";
export type people_select_column_people_aggregate_bool_exp_bool_and_arguments_columns = "active" | "is_placeholder" | "%future added value";
export type people_select_column_people_aggregate_bool_exp_bool_or_arguments_columns = "active" | "is_placeholder" | "%future added value";
export type phase_roles_select_column = "account_id" | "created_at" | "estimated_minutes" | "id" | "phase_id" | "role_id" | "updated_at" | "%future added value";
export type phases_select_column = "account_id" | "color" | "created_at" | "end_date" | "id" | "name" | "project_id" | "start_date" | "updated_at" | "%future added value";
export type project_managers_select_column = "account_id" | "id" | "project_id" | "user_id" | "%future added value";
export type project_members_select_column = "account_id" | "created_at" | "id" | "is_placeholder" | "person_id" | "project_id" | "role_id" | "updated_at" | "workstream_id" | "%future added value";
export type project_members_select_column_project_members_aggregate_bool_exp_bool_and_arguments_columns = "is_placeholder" | "%future added value";
export type project_members_select_column_project_members_aggregate_bool_exp_bool_or_arguments_columns = "is_placeholder" | "%future added value";
export type project_rates_select_column = "account_id" | "created_at" | "id" | "project_id" | "role_id" | "updated_at" | "%future added value";
export type project_roles_select_column = "account_id" | "created_at" | "estimated_minutes" | "id" | "project_id" | "role_id" | "updated_at" | "%future added value";
export type projects_select_column = "account_id" | "active" | "budget_method" | "client_id" | "confirmed" | "created_at" | "emoji" | "id" | "is_template" | "name" | "pricing_model" | "priority" | "rate_card_id" | "rate_type" | "references" | "team_id" | "timesheet_lock_last_updated_by" | "timesheet_lock_status" | "timesheet_lock_status_updated_at" | "timesheet_locked_to" | "updated_at" | "%future added value";
export type projects_select_column_projects_aggregate_bool_exp_bool_and_arguments_columns = "active" | "confirmed" | "is_template" | "%future added value";
export type projects_select_column_projects_aggregate_bool_exp_bool_or_arguments_columns = "active" | "confirmed" | "is_template" | "%future added value";
export type rate_cards_select_column = "account_id" | "active" | "blended_rate" | "blended_rate_card" | "created_at" | "description" | "id" | "name" | "rate_type" | "references" | "updated_at" | "%future added value";
export type rate_cards_select_column_rate_cards_aggregate_bool_exp_bool_and_arguments_columns = "active" | "blended_rate_card" | "%future added value";
export type rate_cards_select_column_rate_cards_aggregate_bool_exp_bool_or_arguments_columns = "active" | "blended_rate_card" | "%future added value";
export type role_charge_out_rates_select_column = "account_id" | "rate_card_id" | "role_id" | "%future added value";
export type roles_select_column = "account_id" | "active" | "created_at" | "id" | "name" | "references" | "updated_at" | "%future added value";
export type roles_select_column_roles_aggregate_bool_exp_bool_and_arguments_columns = "active" | "%future added value";
export type roles_select_column_roles_aggregate_bool_exp_bool_or_arguments_columns = "active" | "%future added value";
export type skills_select_column = "account_id" | "id" | "name" | "%future added value";
export type tags_select_column = "account_id" | "archived" | "created_at" | "id" | "model" | "name" | "updated_at" | "%future added value";
export type tags_select_column_tags_aggregate_bool_exp_bool_and_arguments_columns = "archived" | "%future added value";
export type tags_select_column_tags_aggregate_bool_exp_bool_or_arguments_columns = "archived" | "%future added value";
export type teams_select_column = "account_id" | "created_at" | "id" | "name" | "updated_at" | "%future added value";
export type time_offs_select_column = "account_id" | "created_at" | "end_date_iso" | "holiday_id" | "id" | "leave_type" | "minutes_per_day" | "note" | "person_id" | "start_date_iso" | "updated_at" | "%future added value";
export type type_schedule_totals_roles_select_column = "project_id" | "role_id" | "sum_billable_minutes" | "sum_nonbillable_minutes" | "%future added value";
export type users_select_column = "account_id" | "created_at" | "current_sign_in_at" | "email" | "favourite_people" | "favourite_projects" | "first_name" | "id" | "image_key" | "last_name" | "permissions" | "references" | "role_name" | "updated_at" | "view_id" | "viewed_welcome" | "%future added value";
export type users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns = "viewed_welcome" | "%future added value";
export type users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns = "viewed_welcome" | "%future added value";
export type views_select_column = "description" | "id" | "name" | "people_filters" | "project_filters" | "%future added value";
export type workstreams_select_column = "archived" | "id" | "name" | "%future added value";
export type workstreams_select_column_workstreams_aggregate_bool_exp_bool_and_arguments_columns = "archived" | "%future added value";
export type workstreams_select_column_workstreams_aggregate_bool_exp_bool_or_arguments_columns = "archived" | "%future added value";
export type projects_bool_exp = {
  _and?: ReadonlyArray<projects_bool_exp> | null | undefined;
  _not?: projects_bool_exp | null | undefined;
  _or?: ReadonlyArray<projects_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  actuals?: actuals_bool_exp | null | undefined;
  actuals_aggregate?: actuals_aggregate_bool_exp | null | undefined;
  archivable?: Boolean_comparison_exp | null | undefined;
  assignments?: assignments_bool_exp | null | undefined;
  assignments_aggregate?: assignments_aggregate_bool_exp | null | undefined;
  budget_method?: project_budget_method_comparison_exp | null | undefined;
  calc_end_date?: String_comparison_exp | null | undefined;
  calc_start_date?: String_comparison_exp | null | undefined;
  client?: clients_bool_exp | null | undefined;
  client_id?: Int_comparison_exp | null | undefined;
  confirmed?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  custom_checkbox_values?: custom_checkbox_values_bool_exp | null | undefined;
  custom_checkbox_values_aggregate?: custom_checkbox_values_aggregate_bool_exp | null | undefined;
  custom_date_values?: custom_date_values_bool_exp | null | undefined;
  custom_date_values_aggregate?: custom_date_values_aggregate_bool_exp | null | undefined;
  custom_select_values?: custom_select_values_bool_exp | null | undefined;
  custom_select_values_aggregate?: custom_select_values_aggregate_bool_exp | null | undefined;
  custom_text_values?: custom_text_values_bool_exp | null | undefined;
  custom_text_values_aggregate?: custom_text_values_aggregate_bool_exp | null | undefined;
  emoji?: String_comparison_exp | null | undefined;
  expenses_budget_private?: numeric_comparison_exp | null | undefined;
  ext_project_links?: ext_project_link_bool_exp | null | undefined;
  has_actuals?: Boolean_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  is_template?: Boolean_comparison_exp | null | undefined;
  links?: project_links_bool_exp | null | undefined;
  managers?: project_managers_bool_exp | null | undefined;
  managers_aggregate?: project_managers_aggregate_bool_exp | null | undefined;
  members?: project_members_bool_exp | null | undefined;
  members_aggregate?: project_members_aggregate_bool_exp | null | undefined;
  milestones?: milestones_bool_exp | null | undefined;
  milestones_aggregate?: milestones_aggregate_bool_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  no_phase_revenue_budget_private?: numeric_comparison_exp | null | undefined;
  notes?: notes_bool_exp | null | undefined;
  notes_aggregate?: notes_aggregate_bool_exp | null | undefined;
  other_costs?: other_costs_bool_exp | null | undefined;
  other_costs_aggregate?: other_costs_aggregate_bool_exp | null | undefined;
  person_requests?: person_requests_bool_exp | null | undefined;
  phase_roles?: phase_roles_bool_exp | null | undefined;
  phase_roles_aggregate?: phase_roles_aggregate_bool_exp | null | undefined;
  phases?: phases_bool_exp | null | undefined;
  phases_aggregate?: phases_aggregate_bool_exp | null | undefined;
  pricing_model?: String_comparison_exp | null | undefined;
  pricing_model_readable?: String_comparison_exp | null | undefined;
  priority?: String_comparison_exp | null | undefined;
  project_rates?: project_rates_bool_exp | null | undefined;
  project_rates_aggregate?: project_rates_aggregate_bool_exp | null | undefined;
  project_roles?: project_roles_bool_exp | null | undefined;
  project_roles_aggregate?: project_roles_aggregate_bool_exp | null | undefined;
  project_tags?: project_tags_bool_exp | null | undefined;
  project_workstreams?: project_workstreams_bool_exp | null | undefined;
  rate_card?: rate_cards_bool_exp | null | undefined;
  rate_card_id?: Int_comparison_exp | null | undefined;
  rate_type?: String_comparison_exp | null | undefined;
  references?: jsonb_comparison_exp | null | undefined;
  schedule_totals?: type_schedule_totals_bool_exp | null | undefined;
  schedule_totals_roles?: type_schedule_totals_roles_bool_exp | null | undefined;
  summary?: v_summary_total_bool_exp | null | undefined;
  tags?: jsonb_comparison_exp | null | undefined;
  team?: teams_bool_exp | null | undefined;
  team_id?: Int_comparison_exp | null | undefined;
  timesheet_lock_last_updated_by?: String_comparison_exp | null | undefined;
  timesheet_lock_status?: timesheet_lock_status_comparison_exp | null | undefined;
  timesheet_lock_status_updated_at?: timestamp_comparison_exp | null | undefined;
  timesheet_locked_to?: date_comparison_exp | null | undefined;
  total_budget_private?: numeric_comparison_exp | null | undefined;
  type_schedule_totals?: type_schedule_totals_bool_exp | null | undefined;
  type_schedule_totals_roles?: type_schedule_totals_roles_bool_exp | null | undefined;
  type_schedule_totals_roles_aggregate?: type_schedule_totals_roles_aggregate_bool_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  workstreams_computed?: jsonb_comparison_exp | null | undefined;
};
export type accounts_bool_exp = {
  _and?: ReadonlyArray<accounts_bool_exp> | null | undefined;
  _not?: accounts_bool_exp | null | undefined;
  _or?: ReadonlyArray<accounts_bool_exp> | null | undefined;
  account_type?: String_comparison_exp | null | undefined;
  accounts?: accounts_bool_exp | null | undefined;
  accounts_aggregate?: accounts_aggregate_bool_exp | null | undefined;
  allocated_views_enabled?: Boolean_comparison_exp | null | undefined;
  allow_future_actuals?: Boolean_comparison_exp | null | undefined;
  allow_profile_photos?: Boolean_comparison_exp | null | undefined;
  alternative_account?: accounts_bool_exp | null | undefined;
  alternative_account_id?: Int_comparison_exp | null | undefined;
  billing_method?: String_comparison_exp | null | undefined;
  billing_type?: billing_type_comparison_exp | null | undefined;
  business_days?: String_array_comparison_exp | null | undefined;
  cancel_reasons?: cancel_reasons_bool_exp | null | undefined;
  clients?: clients_bool_exp | null | undefined;
  clients_aggregate?: clients_aggregate_bool_exp | null | undefined;
  competencies?: competencies_bool_exp | null | undefined;
  copy_started_at?: Int_comparison_exp | null | undefined;
  copy_status?: String_comparison_exp | null | undefined;
  currency?: String_comparison_exp | null | undefined;
  custom_checkbox_types?: custom_checkbox_types_bool_exp | null | undefined;
  custom_checkbox_types_aggregate?: custom_checkbox_types_aggregate_bool_exp | null | undefined;
  custom_date_types?: custom_date_types_bool_exp | null | undefined;
  custom_date_types_aggregate?: custom_date_types_aggregate_bool_exp | null | undefined;
  custom_select_types?: custom_select_types_bool_exp | null | undefined;
  custom_select_types_aggregate?: custom_select_types_aggregate_bool_exp | null | undefined;
  custom_text_types?: custom_text_types_bool_exp | null | undefined;
  custom_text_types_aggregate?: custom_text_types_aggregate_bool_exp | null | undefined;
  default_full_time_minutes?: Int_comparison_exp | null | undefined;
  ext_people?: ext_person_bool_exp | null | undefined;
  ext_people_aggregate?: ext_person_aggregate_bool_exp | null | undefined;
  ext_project_members?: ext_project_member_bool_exp | null | undefined;
  ext_projects?: ext_project_bool_exp | null | undefined;
  ext_projects_aggregate?: ext_project_aggregate_bool_exp | null | undefined;
  features_accounts?: features_accounts_bool_exp | null | undefined;
  holidays?: holidays_bool_exp | null | undefined;
  holidays_aggregate?: holidays_aggregate_bool_exp | null | undefined;
  holidays_groups?: holidays_groups_bool_exp | null | undefined;
  holidays_groups_aggregate?: holidays_groups_aggregate_bool_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  integrations?: jsonb_comparison_exp | null | undefined;
  integrationsV2?: integration_bool_exp | null | undefined;
  invitations?: invitations_bool_exp | null | undefined;
  invitations_aggregate?: invitations_aggregate_bool_exp | null | undefined;
  last_copied?: timestamp_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  people?: people_bool_exp | null | undefined;
  people_aggregate?: people_aggregate_bool_exp | null | undefined;
  person_requests?: person_requests_bool_exp | null | undefined;
  project_members?: project_members_bool_exp | null | undefined;
  project_members_aggregate?: project_members_aggregate_bool_exp | null | undefined;
  projects?: projects_bool_exp | null | undefined;
  projects_aggregate?: projects_aggregate_bool_exp | null | undefined;
  rate_cards?: rate_cards_bool_exp | null | undefined;
  rate_cards_aggregate?: rate_cards_aggregate_bool_exp | null | undefined;
  rate_type?: String_comparison_exp | null | undefined;
  references?: jsonb_comparison_exp | null | undefined;
  roles?: roles_bool_exp | null | undefined;
  roles_aggregate?: roles_aggregate_bool_exp | null | undefined;
  saved_insights_dashboards?: saved_insights_dashboards_bool_exp | null | undefined;
  saved_reports?: saved_reports_bool_exp | null | undefined;
  secondary_person_field?: String_comparison_exp | null | undefined;
  skills?: skills_bool_exp | null | undefined;
  skills_aggregate?: skills_aggregate_bool_exp | null | undefined;
  subscription?: jsonb_comparison_exp | null | undefined;
  subscription_customer?: jsonb_comparison_exp | null | undefined;
  subscription_entitlements?: jsonb_comparison_exp | null | undefined;
  subscription_type?: String_comparison_exp | null | undefined;
  tags?: tags_bool_exp | null | undefined;
  tags_aggregate?: tags_aggregate_bool_exp | null | undefined;
  teams?: teams_bool_exp | null | undefined;
  teams_aggregate?: teams_aggregate_bool_exp | null | undefined;
  timesheet_lock?: Int_comparison_exp | null | undefined;
  timesheet_lock_method?: String_comparison_exp | null | undefined;
  timesheet_notifications?: Boolean_comparison_exp | null | undefined;
  timesheets_enabled?: Boolean_comparison_exp | null | undefined;
  timesheets_protected?: Boolean_comparison_exp | null | undefined;
  use_week_numbers?: Boolean_comparison_exp | null | undefined;
  user_accounts?: user_accounts_bool_exp | null | undefined;
  users?: users_bool_exp | null | undefined;
  users_aggregate?: users_aggregate_bool_exp | null | undefined;
  views?: views_bool_exp | null | undefined;
  views_aggregate?: views_aggregate_bool_exp | null | undefined;
  website?: String_comparison_exp | null | undefined;
  workstreams?: workstreams_bool_exp | null | undefined;
  workstreams_aggregate?: workstreams_aggregate_bool_exp | null | undefined;
};
export type String_comparison_exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _ilike?: string | null | undefined;
  _in?: ReadonlyArray<string> | null | undefined;
  _iregex?: string | null | undefined;
  _is_null?: boolean | null | undefined;
  _like?: string | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nilike?: string | null | undefined;
  _nin?: ReadonlyArray<string> | null | undefined;
  _niregex?: string | null | undefined;
  _nlike?: string | null | undefined;
  _nregex?: string | null | undefined;
  _nsimilar?: string | null | undefined;
  _regex?: string | null | undefined;
  _similar?: string | null | undefined;
};
export type accounts_aggregate_bool_exp = {
  bool_and?: accounts_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: accounts_aggregate_bool_exp_bool_or | null | undefined;
  count?: accounts_aggregate_bool_exp_count | null | undefined;
};
export type accounts_aggregate_bool_exp_bool_and = {
  arguments: accounts_select_column_accounts_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: accounts_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type Boolean_comparison_exp = {
  _eq?: boolean | null | undefined;
  _gt?: boolean | null | undefined;
  _gte?: boolean | null | undefined;
  _in?: ReadonlyArray<boolean> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: boolean | null | undefined;
  _lte?: boolean | null | undefined;
  _neq?: boolean | null | undefined;
  _nin?: ReadonlyArray<boolean> | null | undefined;
};
export type accounts_aggregate_bool_exp_bool_or = {
  arguments: accounts_select_column_accounts_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: accounts_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type accounts_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<accounts_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: accounts_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type Int_comparison_exp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: ReadonlyArray<number> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: ReadonlyArray<number> | null | undefined;
};
export type billing_type_comparison_exp = {
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type String_array_comparison_exp = {
  _contained_in?: ReadonlyArray<string> | null | undefined;
  _contains?: ReadonlyArray<string> | null | undefined;
  _eq?: ReadonlyArray<string> | null | undefined;
  _gt?: ReadonlyArray<string> | null | undefined;
  _gte?: ReadonlyArray<string> | null | undefined;
  _in?: ReadonlyArray<ReadonlyArray<string>> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: ReadonlyArray<string> | null | undefined;
  _lte?: ReadonlyArray<string> | null | undefined;
  _neq?: ReadonlyArray<string> | null | undefined;
  _nin?: ReadonlyArray<ReadonlyArray<string>> | null | undefined;
};
export type cancel_reasons_bool_exp = {
  _and?: ReadonlyArray<cancel_reasons_bool_exp> | null | undefined;
  _not?: cancel_reasons_bool_exp | null | undefined;
  _or?: ReadonlyArray<cancel_reasons_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  account_name?: String_comparison_exp | null | undefined;
};
export type clients_bool_exp = {
  _and?: ReadonlyArray<clients_bool_exp> | null | undefined;
  _not?: clients_bool_exp | null | undefined;
  _or?: ReadonlyArray<clients_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  archivable?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  deletable?: Boolean_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  image_key?: String_comparison_exp | null | undefined;
  internal?: Boolean_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  projects?: projects_bool_exp | null | undefined;
  projects_aggregate?: projects_aggregate_bool_exp | null | undefined;
  real_client?: Boolean_comparison_exp | null | undefined;
  references?: jsonb_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  website?: String_comparison_exp | null | undefined;
};
export type timestamp_comparison_exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: ReadonlyArray<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: ReadonlyArray<string> | null | undefined;
};
export type projects_aggregate_bool_exp = {
  bool_and?: projects_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: projects_aggregate_bool_exp_bool_or | null | undefined;
  count?: projects_aggregate_bool_exp_count | null | undefined;
};
export type projects_aggregate_bool_exp_bool_and = {
  arguments: projects_select_column_projects_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: projects_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type projects_aggregate_bool_exp_bool_or = {
  arguments: projects_select_column_projects_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: projects_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type projects_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<projects_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: projects_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type jsonb_comparison_exp = {
  _cast?: jsonb_cast_exp | null | undefined;
  _contained_in?: any | null | undefined;
  _contains?: any | null | undefined;
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _has_key?: string | null | undefined;
  _has_keys_all?: ReadonlyArray<string> | null | undefined;
  _has_keys_any?: ReadonlyArray<string> | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type jsonb_cast_exp = {
  String?: String_comparison_exp | null | undefined;
};
export type clients_aggregate_bool_exp = {
  bool_and?: clients_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: clients_aggregate_bool_exp_bool_or | null | undefined;
  count?: clients_aggregate_bool_exp_count | null | undefined;
};
export type clients_aggregate_bool_exp_bool_and = {
  arguments: clients_select_column_clients_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: clients_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type clients_aggregate_bool_exp_bool_or = {
  arguments: clients_select_column_clients_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: clients_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type clients_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<clients_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: clients_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type competencies_bool_exp = {
  _and?: ReadonlyArray<competencies_bool_exp> | null | undefined;
  _not?: competencies_bool_exp | null | undefined;
  _or?: ReadonlyArray<competencies_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  level?: Int_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  skill?: skills_bool_exp | null | undefined;
  skill_id?: Int_comparison_exp | null | undefined;
};
export type people_bool_exp = {
  _and?: ReadonlyArray<people_bool_exp> | null | undefined;
  _not?: people_bool_exp | null | undefined;
  _or?: ReadonlyArray<people_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  actuals?: actuals_bool_exp | null | undefined;
  actuals_aggregate?: actuals_aggregate_bool_exp | null | undefined;
  archivable?: Boolean_comparison_exp | null | undefined;
  assignments?: assignments_bool_exp | null | undefined;
  assignments_aggregate?: assignments_aggregate_bool_exp | null | undefined;
  competencies?: competencies_bool_exp | null | undefined;
  contracts?: contracts_bool_exp | null | undefined;
  contracts_aggregate?: contracts_aggregate_bool_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  current_contract?: contracts_bool_exp | null | undefined;
  current_role?: roles_bool_exp | null | undefined;
  custom_checkbox_values?: custom_checkbox_values_bool_exp | null | undefined;
  custom_checkbox_values_aggregate?: custom_checkbox_values_aggregate_bool_exp | null | undefined;
  custom_date_values?: custom_date_values_bool_exp | null | undefined;
  custom_date_values_aggregate?: custom_date_values_aggregate_bool_exp | null | undefined;
  custom_select_values?: custom_select_values_bool_exp | null | undefined;
  custom_select_values_aggregate?: custom_select_values_aggregate_bool_exp | null | undefined;
  custom_text_values?: custom_text_values_bool_exp | null | undefined;
  custom_text_values_aggregate?: custom_text_values_aggregate_bool_exp | null | undefined;
  email?: String_comparison_exp | null | undefined;
  ext_person_links?: ext_person_link_bool_exp | null | undefined;
  first_name?: String_comparison_exp | null | undefined;
  holidays_group?: holidays_groups_bool_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  image_key?: String_comparison_exp | null | undefined;
  is_placeholder?: Boolean_comparison_exp | null | undefined;
  last_name?: String_comparison_exp | null | undefined;
  links?: people_links_bool_exp | null | undefined;
  managers?: people_managers_bool_exp | null | undefined;
  managers_aggregate?: people_managers_aggregate_bool_exp | null | undefined;
  people_notes?: people_notes_bool_exp | null | undefined;
  people_notes_aggregate?: people_notes_aggregate_bool_exp | null | undefined;
  person_requests?: person_requests_bool_exp | null | undefined;
  placeholder_count?: Int_comparison_exp | null | undefined;
  placeholder_suggestions?: placeholder_suggestions_bool_exp | null | undefined;
  project_memberships?: project_members_bool_exp | null | undefined;
  project_memberships_aggregate?: project_members_aggregate_bool_exp | null | undefined;
  references?: jsonb_comparison_exp | null | undefined;
  tags?: jsonb_comparison_exp | null | undefined;
  team?: teams_bool_exp | null | undefined;
  team_id?: Int_comparison_exp | null | undefined;
  time_offs?: time_offs_bool_exp | null | undefined;
  time_offs_aggregate?: time_offs_aggregate_bool_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type actuals_bool_exp = {
  _and?: ReadonlyArray<actuals_bool_exp> | null | undefined;
  _not?: actuals_bool_exp | null | undefined;
  _or?: ReadonlyArray<actuals_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  billable_minutes?: Int_comparison_exp | null | undefined;
  billable_note?: String_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  date_iso?: date_comparison_exp | null | undefined;
  date_runn?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  nonbillable_minutes?: Int_comparison_exp | null | undefined;
  nonbillable_note?: String_comparison_exp | null | undefined;
  origin_data?: jsonb_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  phase?: phases_bool_exp | null | undefined;
  phase_id?: Int_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  role?: roles_bool_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  workstream_id?: Int_comparison_exp | null | undefined;
};
export type date_comparison_exp = {
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type phases_bool_exp = {
  _and?: ReadonlyArray<phases_bool_exp> | null | undefined;
  _not?: phases_bool_exp | null | undefined;
  _or?: ReadonlyArray<phases_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  actuals?: actuals_bool_exp | null | undefined;
  actuals_aggregate?: actuals_aggregate_bool_exp | null | undefined;
  assignments?: assignments_bool_exp | null | undefined;
  assignments_aggregate?: assignments_aggregate_bool_exp | null | undefined;
  color?: String_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  end_date?: date_comparison_exp | null | undefined;
  end_date_runn?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  phase_roles?: phase_roles_bool_exp | null | undefined;
  phase_roles_aggregate?: phase_roles_aggregate_bool_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  revenue_budget_private?: numeric_comparison_exp | null | undefined;
  start_date?: date_comparison_exp | null | undefined;
  start_date_runn?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type actuals_aggregate_bool_exp = {
  count?: actuals_aggregate_bool_exp_count | null | undefined;
};
export type actuals_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<actuals_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: actuals_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type assignments_bool_exp = {
  _and?: ReadonlyArray<assignments_bool_exp> | null | undefined;
  _not?: assignments_bool_exp | null | undefined;
  _or?: ReadonlyArray<assignments_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  end_date_iso?: date_comparison_exp | null | undefined;
  end_date_runn?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  is_billable?: Boolean_comparison_exp | null | undefined;
  is_template?: Boolean_comparison_exp | null | undefined;
  minutes_per_day?: Int_comparison_exp | null | undefined;
  non_working_day?: Boolean_comparison_exp | null | undefined;
  note?: String_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  phase?: phases_bool_exp | null | undefined;
  phase_id?: Int_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  role?: roles_bool_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
  start_date_iso?: date_comparison_exp | null | undefined;
  start_date_runn?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  workstream_id?: Int_comparison_exp | null | undefined;
};
export type roles_bool_exp = {
  _and?: ReadonlyArray<roles_bool_exp> | null | undefined;
  _not?: roles_bool_exp | null | undefined;
  _or?: ReadonlyArray<roles_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  actuals?: actuals_bool_exp | null | undefined;
  actuals_aggregate?: actuals_aggregate_bool_exp | null | undefined;
  assignments?: assignments_bool_exp | null | undefined;
  assignments_aggregate?: assignments_aggregate_bool_exp | null | undefined;
  contracts?: contracts_bool_exp | null | undefined;
  contracts_aggregate?: contracts_aggregate_bool_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  default_hour_cost_private?: numeric_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  project_members?: project_members_bool_exp | null | undefined;
  project_members_aggregate?: project_members_aggregate_bool_exp | null | undefined;
  project_rates?: project_rates_bool_exp | null | undefined;
  project_rates_aggregate?: project_rates_aggregate_bool_exp | null | undefined;
  references?: jsonb_comparison_exp | null | undefined;
  role_charge_out_rates?: role_charge_out_rates_bool_exp | null | undefined;
  role_charge_out_rates_aggregate?: role_charge_out_rates_aggregate_bool_exp | null | undefined;
  type_schedule_totals_roles?: type_schedule_totals_roles_bool_exp | null | undefined;
  type_schedule_totals_roles_aggregate?: type_schedule_totals_roles_aggregate_bool_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type assignments_aggregate_bool_exp = {
  bool_and?: assignments_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: assignments_aggregate_bool_exp_bool_or | null | undefined;
  count?: assignments_aggregate_bool_exp_count | null | undefined;
};
export type assignments_aggregate_bool_exp_bool_and = {
  arguments: assignments_select_column_assignments_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: assignments_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type assignments_aggregate_bool_exp_bool_or = {
  arguments: assignments_select_column_assignments_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: assignments_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type assignments_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<assignments_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: assignments_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type contracts_bool_exp = {
  _and?: ReadonlyArray<contracts_bool_exp> | null | undefined;
  _not?: contracts_bool_exp | null | undefined;
  _or?: ReadonlyArray<contracts_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  cost_padded_private?: numeric_comparison_exp | null | undefined;
  cost_private?: numeric_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  employment_type?: String_comparison_exp | null | undefined;
  end_date_iso?: date_comparison_exp | null | undefined;
  end_date_runn?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  job_title?: String_comparison_exp | null | undefined;
  minutes_per_day?: Int_comparison_exp | null | undefined;
  permanent?: Boolean_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  role?: roles_bool_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
  rostered_days?: Int_array_comparison_exp | null | undefined;
  start_date_iso?: date_comparison_exp | null | undefined;
  start_date_runn?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type numeric_comparison_exp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: ReadonlyArray<number> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: ReadonlyArray<number> | null | undefined;
};
export type Int_array_comparison_exp = {
  _contained_in?: ReadonlyArray<number> | null | undefined;
  _contains?: ReadonlyArray<number> | null | undefined;
  _eq?: ReadonlyArray<number> | null | undefined;
  _gt?: ReadonlyArray<number> | null | undefined;
  _gte?: ReadonlyArray<number> | null | undefined;
  _in?: ReadonlyArray<ReadonlyArray<number>> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: ReadonlyArray<number> | null | undefined;
  _lte?: ReadonlyArray<number> | null | undefined;
  _neq?: ReadonlyArray<number> | null | undefined;
  _nin?: ReadonlyArray<ReadonlyArray<number>> | null | undefined;
};
export type contracts_aggregate_bool_exp = {
  count?: contracts_aggregate_bool_exp_count | null | undefined;
};
export type contracts_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<contracts_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: contracts_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type project_members_bool_exp = {
  _and?: ReadonlyArray<project_members_bool_exp> | null | undefined;
  _not?: project_members_bool_exp | null | undefined;
  _or?: ReadonlyArray<project_members_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  actuals_count?: Int_comparison_exp | null | undefined;
  assignments_count?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  has_actuals?: Boolean_comparison_exp | null | undefined;
  has_assignments?: Boolean_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  is_placeholder?: Boolean_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  role?: roles_bool_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  workstream?: workstreams_bool_exp | null | undefined;
  workstream_id?: Int_comparison_exp | null | undefined;
};
export type workstreams_bool_exp = {
  _and?: ReadonlyArray<workstreams_bool_exp> | null | undefined;
  _not?: workstreams_bool_exp | null | undefined;
  _or?: ReadonlyArray<workstreams_bool_exp> | null | undefined;
  archived?: Boolean_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  project_workstreams?: project_workstreams_bool_exp | null | undefined;
  workstreams_account?: accounts_bool_exp | null | undefined;
};
export type project_workstreams_bool_exp = {
  _and?: ReadonlyArray<project_workstreams_bool_exp> | null | undefined;
  _not?: project_workstreams_bool_exp | null | undefined;
  _or?: ReadonlyArray<project_workstreams_bool_exp> | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  workstream?: workstreams_bool_exp | null | undefined;
  workstream_id?: Int_comparison_exp | null | undefined;
};
export type project_members_aggregate_bool_exp = {
  bool_and?: project_members_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: project_members_aggregate_bool_exp_bool_or | null | undefined;
  count?: project_members_aggregate_bool_exp_count | null | undefined;
};
export type project_members_aggregate_bool_exp_bool_and = {
  arguments: project_members_select_column_project_members_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: project_members_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type project_members_aggregate_bool_exp_bool_or = {
  arguments: project_members_select_column_project_members_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: project_members_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type project_members_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<project_members_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: project_members_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type project_rates_bool_exp = {
  _and?: ReadonlyArray<project_rates_bool_exp> | null | undefined;
  _not?: project_rates_bool_exp | null | undefined;
  _or?: ReadonlyArray<project_rates_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  rate_private?: numeric_comparison_exp | null | undefined;
  role?: roles_bool_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type project_rates_aggregate_bool_exp = {
  count?: project_rates_aggregate_bool_exp_count | null | undefined;
};
export type project_rates_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<project_rates_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: project_rates_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type role_charge_out_rates_bool_exp = {
  _and?: ReadonlyArray<role_charge_out_rates_bool_exp> | null | undefined;
  _not?: role_charge_out_rates_bool_exp | null | undefined;
  _or?: ReadonlyArray<role_charge_out_rates_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  charge_out_rate_private?: numeric_comparison_exp | null | undefined;
  rate_card?: rate_cards_bool_exp | null | undefined;
  rate_card_id?: Int_comparison_exp | null | undefined;
  role?: roles_bool_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
};
export type rate_cards_bool_exp = {
  _and?: ReadonlyArray<rate_cards_bool_exp> | null | undefined;
  _not?: rate_cards_bool_exp | null | undefined;
  _or?: ReadonlyArray<rate_cards_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  archivable?: Boolean_comparison_exp | null | undefined;
  blended_rate?: numeric_comparison_exp | null | undefined;
  blended_rate_card?: Boolean_comparison_exp | null | undefined;
  blended_rate_private?: numeric_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  description?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  projects?: projects_bool_exp | null | undefined;
  projects_aggregate?: projects_aggregate_bool_exp | null | undefined;
  rate_type?: String_comparison_exp | null | undefined;
  references?: jsonb_comparison_exp | null | undefined;
  role_charge_out_rates?: role_charge_out_rates_bool_exp | null | undefined;
  role_charge_out_rates_aggregate?: role_charge_out_rates_aggregate_bool_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type role_charge_out_rates_aggregate_bool_exp = {
  count?: role_charge_out_rates_aggregate_bool_exp_count | null | undefined;
};
export type role_charge_out_rates_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<role_charge_out_rates_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: role_charge_out_rates_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type type_schedule_totals_roles_bool_exp = {
  _and?: ReadonlyArray<type_schedule_totals_roles_bool_exp> | null | undefined;
  _not?: type_schedule_totals_roles_bool_exp | null | undefined;
  _or?: ReadonlyArray<type_schedule_totals_roles_bool_exp> | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  role?: roles_bool_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
  sum_billable_minutes?: Int_comparison_exp | null | undefined;
  sum_nonbillable_minutes?: Int_comparison_exp | null | undefined;
};
export type type_schedule_totals_roles_aggregate_bool_exp = {
  count?: type_schedule_totals_roles_aggregate_bool_exp_count | null | undefined;
};
export type type_schedule_totals_roles_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<type_schedule_totals_roles_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: type_schedule_totals_roles_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type phase_roles_bool_exp = {
  _and?: ReadonlyArray<phase_roles_bool_exp> | null | undefined;
  _not?: phase_roles_bool_exp | null | undefined;
  _or?: ReadonlyArray<phase_roles_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  estimated_minutes?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  phase_id?: Int_comparison_exp | null | undefined;
  role?: roles_bool_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type phase_roles_aggregate_bool_exp = {
  count?: phase_roles_aggregate_bool_exp_count | null | undefined;
};
export type phase_roles_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<phase_roles_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: phase_roles_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type custom_checkbox_values_bool_exp = {
  _and?: ReadonlyArray<custom_checkbox_values_bool_exp> | null | undefined;
  _not?: custom_checkbox_values_bool_exp | null | undefined;
  _or?: ReadonlyArray<custom_checkbox_values_bool_exp> | null | undefined;
  custom_checkbox_type_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: custom_model_comparison_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  value?: Boolean_comparison_exp | null | undefined;
};
export type custom_model_comparison_exp = {
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type custom_checkbox_values_aggregate_bool_exp = {
  bool_and?: custom_checkbox_values_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: custom_checkbox_values_aggregate_bool_exp_bool_or | null | undefined;
  count?: custom_checkbox_values_aggregate_bool_exp_count | null | undefined;
};
export type custom_checkbox_values_aggregate_bool_exp_bool_and = {
  arguments: custom_checkbox_values_select_column_custom_checkbox_values_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_checkbox_values_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_checkbox_values_aggregate_bool_exp_bool_or = {
  arguments: custom_checkbox_values_select_column_custom_checkbox_values_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_checkbox_values_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_checkbox_values_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<custom_checkbox_values_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: custom_checkbox_values_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type custom_date_values_bool_exp = {
  _and?: ReadonlyArray<custom_date_values_bool_exp> | null | undefined;
  _not?: custom_date_values_bool_exp | null | undefined;
  _or?: ReadonlyArray<custom_date_values_bool_exp> | null | undefined;
  custom_date_type?: custom_date_types_bool_exp | null | undefined;
  custom_date_type_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: custom_model_comparison_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  value?: date_comparison_exp | null | undefined;
};
export type custom_date_types_bool_exp = {
  _and?: ReadonlyArray<custom_date_types_bool_exp> | null | undefined;
  _not?: custom_date_types_bool_exp | null | undefined;
  _or?: ReadonlyArray<custom_date_types_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  description?: String_comparison_exp | null | undefined;
  filterable_in_planner?: Boolean_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: custom_model_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  required?: Boolean_comparison_exp | null | undefined;
  show_in_planner?: Boolean_comparison_exp | null | undefined;
  sort_order?: Int_comparison_exp | null | undefined;
};
export type custom_date_values_aggregate_bool_exp = {
  count?: custom_date_values_aggregate_bool_exp_count | null | undefined;
};
export type custom_date_values_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<custom_date_values_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: custom_date_values_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type custom_select_values_bool_exp = {
  _and?: ReadonlyArray<custom_select_values_bool_exp> | null | undefined;
  _not?: custom_select_values_bool_exp | null | undefined;
  _or?: ReadonlyArray<custom_select_values_bool_exp> | null | undefined;
  custom_select_option?: custom_select_options_bool_exp | null | undefined;
  custom_select_option_id?: Int_comparison_exp | null | undefined;
  custom_select_type_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: custom_model_comparison_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
};
export type custom_select_options_bool_exp = {
  _and?: ReadonlyArray<custom_select_options_bool_exp> | null | undefined;
  _not?: custom_select_options_bool_exp | null | undefined;
  _or?: ReadonlyArray<custom_select_options_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  custom_select_type?: custom_select_types_bool_exp | null | undefined;
  custom_select_type_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
};
export type custom_select_types_bool_exp = {
  _and?: ReadonlyArray<custom_select_types_bool_exp> | null | undefined;
  _not?: custom_select_types_bool_exp | null | undefined;
  _or?: ReadonlyArray<custom_select_types_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  custom_select_options?: custom_select_options_bool_exp | null | undefined;
  custom_select_options_aggregate?: custom_select_options_aggregate_bool_exp | null | undefined;
  description?: String_comparison_exp | null | undefined;
  filterable_in_planner?: Boolean_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: custom_model_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  required?: Boolean_comparison_exp | null | undefined;
  show_in_planner?: Boolean_comparison_exp | null | undefined;
  single_select?: Boolean_comparison_exp | null | undefined;
  sort_order?: Int_comparison_exp | null | undefined;
};
export type custom_select_options_aggregate_bool_exp = {
  count?: custom_select_options_aggregate_bool_exp_count | null | undefined;
};
export type custom_select_options_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<custom_select_options_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: custom_select_options_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type custom_select_values_aggregate_bool_exp = {
  count?: custom_select_values_aggregate_bool_exp_count | null | undefined;
};
export type custom_select_values_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<custom_select_values_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: custom_select_values_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type custom_text_values_bool_exp = {
  _and?: ReadonlyArray<custom_text_values_bool_exp> | null | undefined;
  _not?: custom_text_values_bool_exp | null | undefined;
  _or?: ReadonlyArray<custom_text_values_bool_exp> | null | undefined;
  custom_text_type?: custom_text_types_bool_exp | null | undefined;
  custom_text_type_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: custom_model_comparison_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  value?: String_comparison_exp | null | undefined;
};
export type custom_text_types_bool_exp = {
  _and?: ReadonlyArray<custom_text_types_bool_exp> | null | undefined;
  _not?: custom_text_types_bool_exp | null | undefined;
  _or?: ReadonlyArray<custom_text_types_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  description?: String_comparison_exp | null | undefined;
  filterable_in_planner?: Boolean_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: custom_model_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  required?: Boolean_comparison_exp | null | undefined;
  show_in_planner?: Boolean_comparison_exp | null | undefined;
  sort_order?: Int_comparison_exp | null | undefined;
};
export type custom_text_values_aggregate_bool_exp = {
  count?: custom_text_values_aggregate_bool_exp_count | null | undefined;
};
export type custom_text_values_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<custom_text_values_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: custom_text_values_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type ext_person_link_bool_exp = {
  _and?: ReadonlyArray<ext_person_link_bool_exp> | null | undefined;
  _not?: ext_person_link_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_person_link_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  created_by?: String_comparison_exp | null | undefined;
  ext_person?: ext_person_bool_exp | null | undefined;
  ext_person_id?: Int_comparison_exp | null | undefined;
  note?: String_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type ext_person_bool_exp = {
  _and?: ReadonlyArray<ext_person_bool_exp> | null | undefined;
  _not?: ext_person_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_person_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  deleted?: Boolean_comparison_exp | null | undefined;
  email?: String_comparison_exp | null | undefined;
  ext_current_contract?: ext_contract_bool_exp | null | undefined;
  ext_person_links?: ext_person_link_bool_exp | null | undefined;
  ext_team?: ext_team_bool_exp | null | undefined;
  ext_team_id?: Int_comparison_exp | null | undefined;
  external_id?: String_comparison_exp | null | undefined;
  first_name?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  image_key?: String_comparison_exp | null | undefined;
  integration?: integration_bool_exp | null | undefined;
  integration_id?: Int_comparison_exp | null | undefined;
  is_placeholder?: Boolean_comparison_exp | null | undefined;
  last_name?: String_comparison_exp | null | undefined;
  references?: jsonb_comparison_exp | null | undefined;
  remote_id?: String_comparison_exp | null | undefined;
  sync?: Boolean_comparison_exp | null | undefined;
  tags?: String_array_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type ext_contract_bool_exp = {
  _and?: ReadonlyArray<ext_contract_bool_exp> | null | undefined;
  _not?: ext_contract_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_contract_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  deleted?: Boolean_comparison_exp | null | undefined;
  employment_type?: String_comparison_exp | null | undefined;
  end_date?: timestamp_comparison_exp | null | undefined;
  ext_person_id?: Int_comparison_exp | null | undefined;
  ext_role?: ext_role_bool_exp | null | undefined;
  ext_role_id?: Int_comparison_exp | null | undefined;
  external_id?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  integration_id?: Int_comparison_exp | null | undefined;
  minutes_per_day?: Int_comparison_exp | null | undefined;
  remote_id?: String_comparison_exp | null | undefined;
  rostered_days?: Int_array_comparison_exp | null | undefined;
  start_date?: timestamp_comparison_exp | null | undefined;
  sync?: Boolean_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type ext_role_bool_exp = {
  _and?: ReadonlyArray<ext_role_bool_exp> | null | undefined;
  _not?: ext_role_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_role_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  deleted?: Boolean_comparison_exp | null | undefined;
  external_id?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  integration_id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  remote_id?: String_comparison_exp | null | undefined;
  sync?: Boolean_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type ext_team_bool_exp = {
  _and?: ReadonlyArray<ext_team_bool_exp> | null | undefined;
  _not?: ext_team_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_team_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  deleted?: Boolean_comparison_exp | null | undefined;
  external_id?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  integration_id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  remote_id?: String_comparison_exp | null | undefined;
  sync?: Boolean_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type integration_bool_exp = {
  _and?: ReadonlyArray<integration_bool_exp> | null | undefined;
  _not?: integration_bool_exp | null | undefined;
  _or?: ReadonlyArray<integration_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  category?: String_comparison_exp | null | undefined;
  config?: jsonb_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  ext_people?: ext_person_bool_exp | null | undefined;
  ext_people_aggregate?: ext_person_aggregate_bool_exp | null | undefined;
  ext_projects?: ext_project_bool_exp | null | undefined;
  ext_projects_aggregate?: ext_project_aggregate_bool_exp | null | undefined;
  ext_time_offs?: ext_time_off_bool_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  integration_service?: integration_service_bool_exp | null | undefined;
  integration_service_id?: Int_comparison_exp | null | undefined;
  integration_syncs?: integration_sync_bool_exp | null | undefined;
  last_sync_at?: timestamptz_comparison_exp | null | undefined;
  next_sync_at?: timestamptz_comparison_exp | null | undefined;
  state?: String_comparison_exp | null | undefined;
  sync_interval_minutes?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type ext_person_aggregate_bool_exp = {
  bool_and?: ext_person_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: ext_person_aggregate_bool_exp_bool_or | null | undefined;
  count?: ext_person_aggregate_bool_exp_count | null | undefined;
};
export type ext_person_aggregate_bool_exp_bool_and = {
  arguments: ext_person_select_column_ext_person_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: ext_person_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type ext_person_aggregate_bool_exp_bool_or = {
  arguments: ext_person_select_column_ext_person_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: ext_person_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type ext_person_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<ext_person_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ext_person_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type ext_project_bool_exp = {
  _and?: ReadonlyArray<ext_project_bool_exp> | null | undefined;
  _not?: ext_project_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_project_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  confirmed?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  deleted?: Boolean_comparison_exp | null | undefined;
  emoji?: String_comparison_exp | null | undefined;
  expenses_budget?: numeric_comparison_exp | null | undefined;
  ext_project_links?: ext_project_link_bool_exp | null | undefined;
  ext_project_members?: ext_project_member_bool_exp | null | undefined;
  external_id?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  integration?: integration_bool_exp | null | undefined;
  integration_id?: Int_comparison_exp | null | undefined;
  is_template?: Boolean_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  pricing_model?: String_comparison_exp | null | undefined;
  priority?: String_comparison_exp | null | undefined;
  rate_type?: String_comparison_exp | null | undefined;
  references?: jsonb_comparison_exp | null | undefined;
  remote_id?: String_comparison_exp | null | undefined;
  remote_key?: String_comparison_exp | null | undefined;
  remote_url?: String_comparison_exp | null | undefined;
  sync?: Boolean_comparison_exp | null | undefined;
  tags?: String_array_comparison_exp | null | undefined;
  total_budget?: numeric_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type ext_project_link_bool_exp = {
  _and?: ReadonlyArray<ext_project_link_bool_exp> | null | undefined;
  _not?: ext_project_link_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_project_link_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  created_by?: String_comparison_exp | null | undefined;
  ext_project?: ext_project_bool_exp | null | undefined;
  ext_project_id?: Int_comparison_exp | null | undefined;
  note?: String_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type ext_project_member_bool_exp = {
  _and?: ReadonlyArray<ext_project_member_bool_exp> | null | undefined;
  _not?: ext_project_member_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_project_member_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  deleted?: Boolean_comparison_exp | null | undefined;
  ext_person?: ext_person_bool_exp | null | undefined;
  ext_person_id?: Int_comparison_exp | null | undefined;
  ext_project?: ext_project_bool_exp | null | undefined;
  ext_project_id?: Int_comparison_exp | null | undefined;
  external_id?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  integration?: integration_bool_exp | null | undefined;
  integration_id?: Int_comparison_exp | null | undefined;
  is_placeholder?: Boolean_comparison_exp | null | undefined;
  remote_id?: String_comparison_exp | null | undefined;
  sync?: Boolean_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type ext_project_aggregate_bool_exp = {
  bool_and?: ext_project_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: ext_project_aggregate_bool_exp_bool_or | null | undefined;
  count?: ext_project_aggregate_bool_exp_count | null | undefined;
};
export type ext_project_aggregate_bool_exp_bool_and = {
  arguments: ext_project_select_column_ext_project_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: ext_project_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type ext_project_aggregate_bool_exp_bool_or = {
  arguments: ext_project_select_column_ext_project_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: ext_project_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type ext_project_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<ext_project_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ext_project_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type ext_time_off_bool_exp = {
  _and?: ReadonlyArray<ext_time_off_bool_exp> | null | undefined;
  _not?: ext_time_off_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_time_off_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  deleted?: Boolean_comparison_exp | null | undefined;
  end_date?: timestamp_comparison_exp | null | undefined;
  ext_person?: ext_person_bool_exp | null | undefined;
  ext_person_id?: Int_comparison_exp | null | undefined;
  ext_time_off_links?: ext_time_off_link_bool_exp | null | undefined;
  external_id?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  integration?: integration_bool_exp | null | undefined;
  integration_id?: Int_comparison_exp | null | undefined;
  leave_type?: String_comparison_exp | null | undefined;
  note?: String_comparison_exp | null | undefined;
  remote_id?: String_comparison_exp | null | undefined;
  start_date?: timestamp_comparison_exp | null | undefined;
  sync?: Boolean_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type ext_time_off_link_bool_exp = {
  _and?: ReadonlyArray<ext_time_off_link_bool_exp> | null | undefined;
  _not?: ext_time_off_link_bool_exp | null | undefined;
  _or?: ReadonlyArray<ext_time_off_link_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  created_by?: String_comparison_exp | null | undefined;
  ext_time_off?: ext_time_off_bool_exp | null | undefined;
  ext_time_off_id?: Int_comparison_exp | null | undefined;
  note?: String_comparison_exp | null | undefined;
  time_off?: time_offs_bool_exp | null | undefined;
  time_off_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type time_offs_bool_exp = {
  _and?: ReadonlyArray<time_offs_bool_exp> | null | undefined;
  _not?: time_offs_bool_exp | null | undefined;
  _or?: ReadonlyArray<time_offs_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  end_date_iso?: date_comparison_exp | null | undefined;
  end_date_runn?: String_comparison_exp | null | undefined;
  ext_time_off_links?: ext_time_off_link_bool_exp | null | undefined;
  holiday?: holidays_bool_exp | null | undefined;
  holiday_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  leave_type?: String_comparison_exp | null | undefined;
  minutes_per_day?: Int_comparison_exp | null | undefined;
  note?: String_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  start_date_iso?: date_comparison_exp | null | undefined;
  start_date_runn?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type holidays_bool_exp = {
  _and?: ReadonlyArray<holidays_bool_exp> | null | undefined;
  _not?: holidays_bool_exp | null | undefined;
  _or?: ReadonlyArray<holidays_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  date?: date_comparison_exp | null | undefined;
  date_runn?: String_comparison_exp | null | undefined;
  holiday_api_uuid?: uuid_comparison_exp | null | undefined;
  holidays_group?: holidays_groups_bool_exp | null | undefined;
  holidays_group_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  observed?: date_comparison_exp | null | undefined;
  observed_runn?: String_comparison_exp | null | undefined;
  time_offs?: time_offs_bool_exp | null | undefined;
  time_offs_aggregate?: time_offs_aggregate_bool_exp | null | undefined;
  type?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type uuid_comparison_exp = {
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type holidays_groups_bool_exp = {
  _and?: ReadonlyArray<holidays_groups_bool_exp> | null | undefined;
  _not?: holidays_groups_bool_exp | null | undefined;
  _or?: ReadonlyArray<holidays_groups_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  country_code?: String_comparison_exp | null | undefined;
  country_name?: String_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  holidays?: holidays_bool_exp | null | undefined;
  holidays_aggregate?: holidays_aggregate_bool_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  people?: people_bool_exp | null | undefined;
  people_aggregate?: people_aggregate_bool_exp | null | undefined;
  region_name?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type holidays_aggregate_bool_exp = {
  count?: holidays_aggregate_bool_exp_count | null | undefined;
};
export type holidays_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<holidays_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: holidays_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type people_aggregate_bool_exp = {
  bool_and?: people_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: people_aggregate_bool_exp_bool_or | null | undefined;
  count?: people_aggregate_bool_exp_count | null | undefined;
};
export type people_aggregate_bool_exp_bool_and = {
  arguments: people_select_column_people_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: people_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type people_aggregate_bool_exp_bool_or = {
  arguments: people_select_column_people_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: people_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type people_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<people_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: people_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type time_offs_aggregate_bool_exp = {
  count?: time_offs_aggregate_bool_exp_count | null | undefined;
};
export type time_offs_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<time_offs_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: time_offs_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type integration_service_bool_exp = {
  _and?: ReadonlyArray<integration_service_bool_exp> | null | undefined;
  _not?: integration_service_bool_exp | null | undefined;
  _or?: ReadonlyArray<integration_service_bool_exp> | null | undefined;
  active?: Boolean_comparison_exp | null | undefined;
  categories?: String_array_comparison_exp | null | undefined;
  color?: String_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  image_url?: String_comparison_exp | null | undefined;
  integrations?: integration_bool_exp | null | undefined;
  models?: String_array_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  platform?: String_comparison_exp | null | undefined;
  slug?: String_comparison_exp | null | undefined;
  square_image_url?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type integration_sync_bool_exp = {
  _and?: ReadonlyArray<integration_sync_bool_exp> | null | undefined;
  _not?: integration_sync_bool_exp | null | undefined;
  _or?: ReadonlyArray<integration_sync_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  finished_at?: timestamptz_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  info_messages?: String_array_comparison_exp | null | undefined;
  integration?: integration_bool_exp | null | undefined;
  integration_id?: Int_comparison_exp | null | undefined;
  started_at?: timestamptz_comparison_exp | null | undefined;
  state?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type timestamptz_comparison_exp = {
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type people_links_bool_exp = {
  _and?: ReadonlyArray<people_links_bool_exp> | null | undefined;
  _not?: people_links_bool_exp | null | undefined;
  _or?: ReadonlyArray<people_links_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  href?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  show_in_planner?: Boolean_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type people_managers_bool_exp = {
  _and?: ReadonlyArray<people_managers_bool_exp> | null | undefined;
  _not?: people_managers_bool_exp | null | undefined;
  _or?: ReadonlyArray<people_managers_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  user?: users_bool_exp | null | undefined;
  user_id?: Int_comparison_exp | null | undefined;
};
export type users_bool_exp = {
  _and?: ReadonlyArray<users_bool_exp> | null | undefined;
  _not?: users_bool_exp | null | undefined;
  _or?: ReadonlyArray<users_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  current_sign_in_at?: timestamptz_comparison_exp | null | undefined;
  email?: String_comparison_exp | null | undefined;
  favourite_people?: jsonb_comparison_exp | null | undefined;
  favourite_projects?: jsonb_comparison_exp | null | undefined;
  filter_sets?: user_filter_sets_bool_exp | null | undefined;
  first_name?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  image_key?: String_comparison_exp | null | undefined;
  last_name?: String_comparison_exp | null | undefined;
  linkedPerson?: people_bool_exp | null | undefined;
  manageable_people?: people_managers_bool_exp | null | undefined;
  manageable_people_aggregate?: people_managers_aggregate_bool_exp | null | undefined;
  manageable_projects?: project_managers_bool_exp | null | undefined;
  manageable_projects_aggregate?: project_managers_aggregate_bool_exp | null | undefined;
  people?: people_bool_exp | null | undefined;
  people_aggregate?: people_aggregate_bool_exp | null | undefined;
  permissions?: jsonb_comparison_exp | null | undefined;
  references?: jsonb_comparison_exp | null | undefined;
  role_name?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  user_accounts?: user_accounts_bool_exp | null | undefined;
  view?: views_bool_exp | null | undefined;
  view_id?: Int_comparison_exp | null | undefined;
  viewed_welcome?: Boolean_comparison_exp | null | undefined;
};
export type user_filter_sets_bool_exp = {
  _and?: ReadonlyArray<user_filter_sets_bool_exp> | null | undefined;
  _not?: user_filter_sets_bool_exp | null | undefined;
  _or?: ReadonlyArray<user_filter_sets_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  filters?: json_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  type?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  user?: users_bool_exp | null | undefined;
  user_id?: Int_comparison_exp | null | undefined;
};
export type json_comparison_exp = {
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type people_managers_aggregate_bool_exp = {
  count?: people_managers_aggregate_bool_exp_count | null | undefined;
};
export type people_managers_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<people_managers_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: people_managers_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type project_managers_bool_exp = {
  _and?: ReadonlyArray<project_managers_bool_exp> | null | undefined;
  _not?: project_managers_bool_exp | null | undefined;
  _or?: ReadonlyArray<project_managers_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  user_id?: Int_comparison_exp | null | undefined;
};
export type project_managers_aggregate_bool_exp = {
  count?: project_managers_aggregate_bool_exp_count | null | undefined;
};
export type project_managers_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<project_managers_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: project_managers_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type user_accounts_bool_exp = {
  _and?: ReadonlyArray<user_accounts_bool_exp> | null | undefined;
  _not?: user_accounts_bool_exp | null | undefined;
  _or?: ReadonlyArray<user_accounts_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  favourite_people?: jsonb_comparison_exp | null | undefined;
  favourite_projects?: jsonb_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  notification_subscription?: notification_subscriptions_bool_exp | null | undefined;
  permissions?: jsonb_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  user?: users_bool_exp | null | undefined;
  user_id?: Int_comparison_exp | null | undefined;
};
export type notification_subscriptions_bool_exp = {
  _and?: ReadonlyArray<notification_subscriptions_bool_exp> | null | undefined;
  _not?: notification_subscriptions_bool_exp | null | undefined;
  _or?: ReadonlyArray<notification_subscriptions_bool_exp> | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  people_filters?: jsonb_comparison_exp | null | undefined;
  project_filters?: jsonb_comparison_exp | null | undefined;
  user?: users_bool_exp | null | undefined;
};
export type views_bool_exp = {
  _and?: ReadonlyArray<views_bool_exp> | null | undefined;
  _not?: views_bool_exp | null | undefined;
  _or?: ReadonlyArray<views_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  description?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  people_filters?: jsonb_comparison_exp | null | undefined;
  project_filters?: jsonb_comparison_exp | null | undefined;
};
export type people_notes_bool_exp = {
  _and?: ReadonlyArray<people_notes_bool_exp> | null | undefined;
  _not?: people_notes_bool_exp | null | undefined;
  _or?: ReadonlyArray<people_notes_bool_exp> | null | undefined;
  created_at?: timestamptz_comparison_exp | null | undefined;
  created_by?: String_comparison_exp | null | undefined;
  creator_email?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  note?: String_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamptz_comparison_exp | null | undefined;
  user_id?: Int_comparison_exp | null | undefined;
};
export type people_notes_aggregate_bool_exp = {
  count?: people_notes_aggregate_bool_exp_count | null | undefined;
};
export type people_notes_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<people_notes_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: people_notes_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type person_requests_bool_exp = {
  _and?: ReadonlyArray<person_requests_bool_exp> | null | undefined;
  _not?: person_requests_bool_exp | null | undefined;
  _or?: ReadonlyArray<person_requests_bool_exp> | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  status?: person_request_statuses_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  updater_id?: Int_comparison_exp | null | undefined;
  user?: users_bool_exp | null | undefined;
};
export type person_request_statuses_comparison_exp = {
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type placeholder_suggestions_bool_exp = {
  _and?: ReadonlyArray<placeholder_suggestions_bool_exp> | null | undefined;
  _not?: placeholder_suggestions_bool_exp | null | undefined;
  _or?: ReadonlyArray<placeholder_suggestions_bool_exp> | null | undefined;
  placeholder?: people_bool_exp | null | undefined;
  placeholder_id?: Int_comparison_exp | null | undefined;
  suggested_at?: timestamp_comparison_exp | null | undefined;
  suggested_by?: Int_comparison_exp | null | undefined;
  suggested_by_user?: users_bool_exp | null | undefined;
  suggested_person?: people_bool_exp | null | undefined;
  suggested_person_id?: Int_comparison_exp | null | undefined;
};
export type teams_bool_exp = {
  _and?: ReadonlyArray<teams_bool_exp> | null | undefined;
  _not?: teams_bool_exp | null | undefined;
  _or?: ReadonlyArray<teams_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  people?: people_bool_exp | null | undefined;
  people_aggregate?: people_aggregate_bool_exp | null | undefined;
  projects?: projects_bool_exp | null | undefined;
  projects_aggregate?: projects_aggregate_bool_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type skills_bool_exp = {
  _and?: ReadonlyArray<skills_bool_exp> | null | undefined;
  _not?: skills_bool_exp | null | undefined;
  _or?: ReadonlyArray<skills_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
};
export type custom_checkbox_types_bool_exp = {
  _and?: ReadonlyArray<custom_checkbox_types_bool_exp> | null | undefined;
  _not?: custom_checkbox_types_bool_exp | null | undefined;
  _or?: ReadonlyArray<custom_checkbox_types_bool_exp> | null | undefined;
  custom_checkbox_values?: custom_checkbox_values_bool_exp | null | undefined;
  custom_checkbox_values_aggregate?: custom_checkbox_values_aggregate_bool_exp | null | undefined;
  description?: String_comparison_exp | null | undefined;
  filterable_in_planner?: Boolean_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: custom_model_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  required?: Boolean_comparison_exp | null | undefined;
  show_in_planner?: Boolean_comparison_exp | null | undefined;
  sort_order?: Int_comparison_exp | null | undefined;
};
export type custom_checkbox_types_aggregate_bool_exp = {
  bool_and?: custom_checkbox_types_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: custom_checkbox_types_aggregate_bool_exp_bool_or | null | undefined;
  count?: custom_checkbox_types_aggregate_bool_exp_count | null | undefined;
};
export type custom_checkbox_types_aggregate_bool_exp_bool_and = {
  arguments: custom_checkbox_types_select_column_custom_checkbox_types_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_checkbox_types_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_checkbox_types_aggregate_bool_exp_bool_or = {
  arguments: custom_checkbox_types_select_column_custom_checkbox_types_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_checkbox_types_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_checkbox_types_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<custom_checkbox_types_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: custom_checkbox_types_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type custom_date_types_aggregate_bool_exp = {
  bool_and?: custom_date_types_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: custom_date_types_aggregate_bool_exp_bool_or | null | undefined;
  count?: custom_date_types_aggregate_bool_exp_count | null | undefined;
};
export type custom_date_types_aggregate_bool_exp_bool_and = {
  arguments: custom_date_types_select_column_custom_date_types_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_date_types_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_date_types_aggregate_bool_exp_bool_or = {
  arguments: custom_date_types_select_column_custom_date_types_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_date_types_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_date_types_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<custom_date_types_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: custom_date_types_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type custom_select_types_aggregate_bool_exp = {
  bool_and?: custom_select_types_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: custom_select_types_aggregate_bool_exp_bool_or | null | undefined;
  count?: custom_select_types_aggregate_bool_exp_count | null | undefined;
};
export type custom_select_types_aggregate_bool_exp_bool_and = {
  arguments: custom_select_types_select_column_custom_select_types_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_select_types_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_select_types_aggregate_bool_exp_bool_or = {
  arguments: custom_select_types_select_column_custom_select_types_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_select_types_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_select_types_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<custom_select_types_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: custom_select_types_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type custom_text_types_aggregate_bool_exp = {
  bool_and?: custom_text_types_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: custom_text_types_aggregate_bool_exp_bool_or | null | undefined;
  count?: custom_text_types_aggregate_bool_exp_count | null | undefined;
};
export type custom_text_types_aggregate_bool_exp_bool_and = {
  arguments: custom_text_types_select_column_custom_text_types_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_text_types_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_text_types_aggregate_bool_exp_bool_or = {
  arguments: custom_text_types_select_column_custom_text_types_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: custom_text_types_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type custom_text_types_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<custom_text_types_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: custom_text_types_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type features_accounts_bool_exp = {
  _and?: ReadonlyArray<features_accounts_bool_exp> | null | undefined;
  _not?: features_accounts_bool_exp | null | undefined;
  _or?: ReadonlyArray<features_accounts_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  enabled?: Boolean_comparison_exp | null | undefined;
  feature?: features_bool_exp | null | undefined;
  feature_id?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
};
export type features_bool_exp = {
  _and?: ReadonlyArray<features_bool_exp> | null | undefined;
  _not?: features_bool_exp | null | undefined;
  _or?: ReadonlyArray<features_bool_exp> | null | undefined;
  description?: String_comparison_exp | null | undefined;
  enabled?: Boolean_comparison_exp | null | undefined;
  features_accounts?: features_accounts_bool_exp | null | undefined;
  id?: String_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
};
export type holidays_groups_aggregate_bool_exp = {
  count?: holidays_groups_aggregate_bool_exp_count | null | undefined;
};
export type holidays_groups_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<holidays_groups_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: holidays_groups_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type invitations_bool_exp = {
  _and?: ReadonlyArray<invitations_bool_exp> | null | undefined;
  _not?: invitations_bool_exp | null | undefined;
  _or?: ReadonlyArray<invitations_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  add_all_people_to_projects_permission?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  email?: String_comparison_exp | null | undefined;
  expires_at?: timestamptz_comparison_exp | null | undefined;
  fin_permission?: String_comparison_exp | null | undefined;
  from_user_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  manage_account_permission?: Boolean_comparison_exp | null | undefined;
  manage_people_permission?: String_comparison_exp | null | undefined;
  manage_projects_permission?: String_comparison_exp | null | undefined;
  manageable_people?: invitation_people_managers_bool_exp | null | undefined;
  manageable_people_aggregate?: invitation_people_managers_aggregate_bool_exp | null | undefined;
  manageable_projects?: invitation_project_managers_bool_exp | null | undefined;
  manageable_projects_aggregate?: invitation_project_managers_aggregate_bool_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  user_type?: String_comparison_exp | null | undefined;
  uuid?: String_comparison_exp | null | undefined;
  view_planner_permission?: Boolean_comparison_exp | null | undefined;
};
export type invitation_people_managers_bool_exp = {
  _and?: ReadonlyArray<invitation_people_managers_bool_exp> | null | undefined;
  _not?: invitation_people_managers_bool_exp | null | undefined;
  _or?: ReadonlyArray<invitation_people_managers_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  invitation?: invitations_bool_exp | null | undefined;
  invitation_id?: Int_comparison_exp | null | undefined;
  person?: people_bool_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type invitation_people_managers_aggregate_bool_exp = {
  count?: invitation_people_managers_aggregate_bool_exp_count | null | undefined;
};
export type invitation_people_managers_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<invitation_people_managers_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: invitation_people_managers_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type invitation_project_managers_bool_exp = {
  _and?: ReadonlyArray<invitation_project_managers_bool_exp> | null | undefined;
  _not?: invitation_project_managers_bool_exp | null | undefined;
  _or?: ReadonlyArray<invitation_project_managers_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  invitation?: invitations_bool_exp | null | undefined;
  invitation_id?: Int_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type invitation_project_managers_aggregate_bool_exp = {
  count?: invitation_project_managers_aggregate_bool_exp_count | null | undefined;
};
export type invitation_project_managers_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<invitation_project_managers_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: invitation_project_managers_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type invitations_aggregate_bool_exp = {
  bool_and?: invitations_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: invitations_aggregate_bool_exp_bool_or | null | undefined;
  count?: invitations_aggregate_bool_exp_count | null | undefined;
};
export type invitations_aggregate_bool_exp_bool_and = {
  arguments: invitations_select_column_invitations_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: invitations_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type invitations_aggregate_bool_exp_bool_or = {
  arguments: invitations_select_column_invitations_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: invitations_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type invitations_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<invitations_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: invitations_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type rate_cards_aggregate_bool_exp = {
  bool_and?: rate_cards_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: rate_cards_aggregate_bool_exp_bool_or | null | undefined;
  count?: rate_cards_aggregate_bool_exp_count | null | undefined;
};
export type rate_cards_aggregate_bool_exp_bool_and = {
  arguments: rate_cards_select_column_rate_cards_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: rate_cards_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type rate_cards_aggregate_bool_exp_bool_or = {
  arguments: rate_cards_select_column_rate_cards_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: rate_cards_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type rate_cards_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<rate_cards_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: rate_cards_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type roles_aggregate_bool_exp = {
  bool_and?: roles_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: roles_aggregate_bool_exp_bool_or | null | undefined;
  count?: roles_aggregate_bool_exp_count | null | undefined;
};
export type roles_aggregate_bool_exp_bool_and = {
  arguments: roles_select_column_roles_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: roles_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type roles_aggregate_bool_exp_bool_or = {
  arguments: roles_select_column_roles_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: roles_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type roles_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<roles_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: roles_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type saved_insights_dashboards_bool_exp = {
  _and?: ReadonlyArray<saved_insights_dashboards_bool_exp> | null | undefined;
  _not?: saved_insights_dashboards_bool_exp | null | undefined;
  _or?: ReadonlyArray<saved_insights_dashboards_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  creator_id?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  is_private?: Boolean_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  state?: jsonb_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  updater_id?: Int_comparison_exp | null | undefined;
};
export type saved_reports_bool_exp = {
  _and?: ReadonlyArray<saved_reports_bool_exp> | null | undefined;
  _not?: saved_reports_bool_exp | null | undefined;
  _or?: ReadonlyArray<saved_reports_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  creator_id?: Int_comparison_exp | null | undefined;
  hash?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  preset?: reports_bool_exp | null | undefined;
  preset_id?: Int_comparison_exp | null | undefined;
  state?: jsonb_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  updater_id?: Int_comparison_exp | null | undefined;
};
export type reports_bool_exp = {
  _and?: ReadonlyArray<reports_bool_exp> | null | undefined;
  _not?: reports_bool_exp | null | undefined;
  _or?: ReadonlyArray<reports_bool_exp> | null | undefined;
  description?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: custom_model_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  navigation_name?: String_comparison_exp | null | undefined;
  slug?: String_comparison_exp | null | undefined;
  upgraded?: Boolean_comparison_exp | null | undefined;
};
export type skills_aggregate_bool_exp = {
  count?: skills_aggregate_bool_exp_count | null | undefined;
};
export type skills_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<skills_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: skills_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type tags_bool_exp = {
  _and?: ReadonlyArray<tags_bool_exp> | null | undefined;
  _not?: tags_bool_exp | null | undefined;
  _or?: ReadonlyArray<tags_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  archived?: Boolean_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  model?: String_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type tags_aggregate_bool_exp = {
  bool_and?: tags_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: tags_aggregate_bool_exp_bool_or | null | undefined;
  count?: tags_aggregate_bool_exp_count | null | undefined;
};
export type tags_aggregate_bool_exp_bool_and = {
  arguments: tags_select_column_tags_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: tags_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type tags_aggregate_bool_exp_bool_or = {
  arguments: tags_select_column_tags_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: tags_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type tags_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<tags_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: tags_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type teams_aggregate_bool_exp = {
  count?: teams_aggregate_bool_exp_count | null | undefined;
};
export type teams_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<teams_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: teams_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type users_aggregate_bool_exp = {
  bool_and?: users_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: users_aggregate_bool_exp_bool_or | null | undefined;
  count?: users_aggregate_bool_exp_count | null | undefined;
};
export type users_aggregate_bool_exp_bool_and = {
  arguments: users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: users_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type users_aggregate_bool_exp_bool_or = {
  arguments: users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: users_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type users_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<users_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: users_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type views_aggregate_bool_exp = {
  count?: views_aggregate_bool_exp_count | null | undefined;
};
export type views_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<views_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: views_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type workstreams_aggregate_bool_exp = {
  bool_and?: workstreams_aggregate_bool_exp_bool_and | null | undefined;
  bool_or?: workstreams_aggregate_bool_exp_bool_or | null | undefined;
  count?: workstreams_aggregate_bool_exp_count | null | undefined;
};
export type workstreams_aggregate_bool_exp_bool_and = {
  arguments: workstreams_select_column_workstreams_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: workstreams_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type workstreams_aggregate_bool_exp_bool_or = {
  arguments: workstreams_select_column_workstreams_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean | null | undefined;
  filter?: workstreams_bool_exp | null | undefined;
  predicate: Boolean_comparison_exp;
};
export type workstreams_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<workstreams_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: workstreams_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type project_budget_method_comparison_exp = {
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type project_links_bool_exp = {
  _and?: ReadonlyArray<project_links_bool_exp> | null | undefined;
  _not?: project_links_bool_exp | null | undefined;
  _or?: ReadonlyArray<project_links_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  href?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  show_in_planner?: Boolean_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type milestones_bool_exp = {
  _and?: ReadonlyArray<milestones_bool_exp> | null | undefined;
  _not?: milestones_bool_exp | null | undefined;
  _or?: ReadonlyArray<milestones_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  date?: date_comparison_exp | null | undefined;
  date_runn?: String_comparison_exp | null | undefined;
  icon?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  note?: String_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  title?: String_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type milestones_aggregate_bool_exp = {
  count?: milestones_aggregate_bool_exp_count | null | undefined;
};
export type milestones_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<milestones_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: milestones_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type notes_bool_exp = {
  _and?: ReadonlyArray<notes_bool_exp> | null | undefined;
  _not?: notes_bool_exp | null | undefined;
  _or?: ReadonlyArray<notes_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  created_by?: String_comparison_exp | null | undefined;
  creator_email?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  note?: String_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
  user_id?: Int_comparison_exp | null | undefined;
};
export type notes_aggregate_bool_exp = {
  count?: notes_aggregate_bool_exp_count | null | undefined;
};
export type notes_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<notes_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: notes_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type other_costs_bool_exp = {
  _and?: ReadonlyArray<other_costs_bool_exp> | null | undefined;
  _not?: other_costs_bool_exp | null | undefined;
  _or?: ReadonlyArray<other_costs_bool_exp> | null | undefined;
  account?: accounts_bool_exp | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  charge?: numeric_comparison_exp | null | undefined;
  cost?: numeric_comparison_exp | null | undefined;
  date?: date_comparison_exp | null | undefined;
  date_runn?: String_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  name?: String_comparison_exp | null | undefined;
  phase_id?: Int_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
};
export type other_costs_aggregate_bool_exp = {
  count?: other_costs_aggregate_bool_exp_count | null | undefined;
};
export type other_costs_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<other_costs_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: other_costs_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type phases_aggregate_bool_exp = {
  count?: phases_aggregate_bool_exp_count | null | undefined;
};
export type phases_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<phases_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: phases_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type project_roles_bool_exp = {
  _and?: ReadonlyArray<project_roles_bool_exp> | null | undefined;
  _not?: project_roles_bool_exp | null | undefined;
  _or?: ReadonlyArray<project_roles_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  created_at?: timestamp_comparison_exp | null | undefined;
  estimated_minutes?: Int_comparison_exp | null | undefined;
  id?: Int_comparison_exp | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
  updated_at?: timestamp_comparison_exp | null | undefined;
};
export type project_roles_aggregate_bool_exp = {
  count?: project_roles_aggregate_bool_exp_count | null | undefined;
};
export type project_roles_aggregate_bool_exp_count = {
  arguments?: ReadonlyArray<project_roles_select_column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: project_roles_bool_exp | null | undefined;
  predicate: Int_comparison_exp;
};
export type project_tags_bool_exp = {
  _and?: ReadonlyArray<project_tags_bool_exp> | null | undefined;
  _not?: project_tags_bool_exp | null | undefined;
  _or?: ReadonlyArray<project_tags_bool_exp> | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  tag?: tags_bool_exp | null | undefined;
  tag_id?: Int_comparison_exp | null | undefined;
};
export type type_schedule_totals_bool_exp = {
  _and?: ReadonlyArray<type_schedule_totals_bool_exp> | null | undefined;
  _not?: type_schedule_totals_bool_exp | null | undefined;
  _or?: ReadonlyArray<type_schedule_totals_bool_exp> | null | undefined;
  project?: projects_bool_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  sum_billable_minutes?: Int_comparison_exp | null | undefined;
  sum_nonbillable_minutes?: Int_comparison_exp | null | undefined;
};
export type v_summary_total_bool_exp = {
  _and?: ReadonlyArray<v_summary_total_bool_exp> | null | undefined;
  _not?: v_summary_total_bool_exp | null | undefined;
  _or?: ReadonlyArray<v_summary_total_bool_exp> | null | undefined;
  account_id?: Int_comparison_exp | null | undefined;
  actual_phase_id?: Int_comparison_exp | null | undefined;
  assignment_phase_id?: Int_comparison_exp | null | undefined;
  minutes_phase_id?: Int_comparison_exp | null | undefined;
  person_id?: Int_comparison_exp | null | undefined;
  project_id?: Int_comparison_exp | null | undefined;
  role_id?: Int_comparison_exp | null | undefined;
  total_actuals_billable_minutes?: numeric_comparison_exp | null | undefined;
  total_actuals_nonbillable_minutes?: numeric_comparison_exp | null | undefined;
  total_assignment_billable_minutes?: numeric_comparison_exp | null | undefined;
  total_assignment_nonbillable_minutes?: numeric_comparison_exp | null | undefined;
  total_billable_minutes?: numeric_comparison_exp | null | undefined;
  total_nonbillable_minutes?: numeric_comparison_exp | null | undefined;
  workstream_id?: Int_comparison_exp | null | undefined;
};
export type timesheet_lock_status_comparison_exp = {
  _eq?: any | null | undefined;
  _gt?: any | null | undefined;
  _gte?: any | null | undefined;
  _in?: ReadonlyArray<any> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: any | null | undefined;
  _lte?: any | null | undefined;
  _neq?: any | null | undefined;
  _nin?: ReadonlyArray<any> | null | undefined;
};
export type PlannerContainerQuery$variables = {
  peopleFilter?: people_bool_exp | null | undefined;
  plannerStartDate: any;
  projectsFilter?: projects_bool_exp | null | undefined;
  todaysDate: any;
};
export type PlannerContainerQuery$data = {
  readonly billing: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitlementsProvider_billing">;
  } | null | undefined;
  readonly current_user: {
    readonly account: {
      readonly default_full_time_minutes: number;
      readonly id: number;
      readonly name: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"AccountWelcome_user" | "ChartPanel_user" | "ClientForm_viewer" | "CreateBulkProjectsForm_viewer" | "CreatePersonForm_viewer" | "ExternalProjectMemberForm_viewer" | "FilterSetQuery_user" | "HolidaysGroupSelector_viewer" | "ModeMessage_viewer" | "OnboardingDialog_user" | "Overbookings_user" | "PageManager_user" | "PeoplePlannerList_user" | "PermissionsProvider_user" | "PersonAddProjectRow_user" | "PersonCustomEditor_viewer" | "PersonDetails_user" | "PersonForm_viewer" | "PersonSchedulePanel_user" | "PersonSummaryRow_user" | "PersonTagSelector_user" | "PhasesWrapper_user" | "PlaceholderForm_user" | "PlaceholderSummaryRow_user" | "ProjectBudget_viewer" | "ProjectCustomEditor_viewer" | "ProjectForm_viewer" | "ProjectPlannerList_user" | "ProjectSchedulePanel_user" | "RoleForm_viewer" | "RoleSelector_user" | "SelectPersonList_user" | "SingleExternalProjectMemberForm_viewer" | "SkillsSelector_viewer" | "SplitScreenPanel_user" | "SplitScreenRole_user" | "SuperSearchConfig_user" | "SuperSearch_user" | "Timeline_user" | "User_Account_Integrations" | "ViewFieldsTooltip_user">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ServerFlagsProvider_gql">;
};
export type PlannerContainerQuery = {
  response: PlannerContainerQuery$data;
  variables: PlannerContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "peopleFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plannerStartDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectsFilter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todaysDate"
},
v4 = [
  {
    "kind": "Literal",
    "name": "syncSubscription",
    "value": false
  }
],
v5 = {
  "kind": "Variable",
  "name": "peopleFilter",
  "variableName": "peopleFilter"
},
v6 = {
  "kind": "Variable",
  "name": "projectsFilter",
  "variableName": "projectsFilter"
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "kind": "Variable",
  "name": "todaysDate",
  "variableName": "todaysDate"
},
v9 = {
  "kind": "Variable",
  "name": "plannerStartDate",
  "variableName": "plannerStartDate"
},
v10 = [
  (v5/*: any*/),
  (v9/*: any*/),
  (v6/*: any*/)
],
v11 = [
  (v6/*: any*/)
],
v12 = [
  (v5/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "default_full_time_minutes",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image_key",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "real_client",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internal",
  "storageKey": null
},
v24 = [
  (v13/*: any*/),
  (v14/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate_type",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confirmed",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricing_model",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_template",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "teams",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "custom_select_option_id",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "custom_select_type_id",
  "storageKey": null
},
v33 = {
  "alias": "typeId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_select_type_id",
  "storageKey": null
},
v34 = {
  "alias": "optionId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_select_option_id",
  "storageKey": null
},
v35 = {
  "alias": "typeId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_text_type_id",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_text_values",
  "kind": "LinkedField",
  "name": "custom_text_values",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "custom_text_type_id",
      "storageKey": null
    },
    (v35/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": "typeId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_checkbox_type_id",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_checkbox_values",
  "kind": "LinkedField",
  "name": "custom_checkbox_values",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "custom_checkbox_type_id",
      "storageKey": null
    },
    (v37/*: any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "user_id",
  "storageKey": null
},
v40 = [
  (v13/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "projects",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": (v40/*: any*/),
  "storageKey": null
},
v42 = {
  "alias": "typeId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_date_type_id",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_date_values",
  "kind": "LinkedField",
  "name": "custom_date_values",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "custom_date_type_id",
      "storageKey": null
    },
    (v42/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "person_id",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstream_id",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "project_id",
  "storageKey": null
},
v48 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "just_added_timestamp",
      "storageKey": null
    }
  ]
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_placeholder",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "first_name",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "last_name",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "roles",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "workstreams",
  "kind": "LinkedField",
  "name": "workstream",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v55 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v54/*: any*/)
],
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstreams_computed",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "references",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team_id",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "has_actuals",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivable",
  "storageKey": null
},
v62 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "actuals_aggregate",
  "kind": "LinkedField",
  "name": "actuals_aggregate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "actuals_aggregate_fields",
      "kind": "LinkedField",
      "name": "aggregate",
      "plural": false,
      "selections": (v62/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v64 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "assignments_aggregate_fields",
    "kind": "LinkedField",
    "name": "aggregate",
    "plural": false,
    "selections": (v62/*: any*/),
    "storageKey": null
  }
],
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "assignments_aggregate",
  "kind": "LinkedField",
  "name": "assignments_aggregate",
  "plural": false,
  "selections": (v64/*: any*/),
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "show_in_planner",
  "storageKey": null
},
v67 = [
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "href",
    "storageKey": null
  },
  (v66/*: any*/)
],
v68 = {
  "_eq": true
},
v69 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "active": (v68/*: any*/)
    }
  }
],
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remote_id",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integration_id",
  "storageKey": null
},
v73 = {
  "_eq": false
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ext_person_id",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "client_id",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate_card_id",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updated_at",
  "storageKey": null
},
v80 = [
  (v13/*: any*/),
  (v76/*: any*/),
  (v57/*: any*/),
  (v79/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "creator_email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "created_by",
    "storageKey": null
  },
  (v39/*: any*/)
],
v81 = {
  "alias": "start_date",
  "args": null,
  "kind": "ScalarField",
  "name": "start_date_runn",
  "storageKey": null
},
v82 = {
  "alias": "end_date",
  "args": null,
  "kind": "ScalarField",
  "name": "end_date_runn",
  "storageKey": null
},
v83 = {
  "alias": "cost",
  "args": null,
  "kind": "ScalarField",
  "name": "cost_private",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutes_per_day",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "job_title",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "concreteType": "people",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": (v40/*: any*/),
  "storageKey": null
},
v87 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "_gte",
            "variableName": "plannerStartDate"
          }
        ],
        "kind": "ObjectValue",
        "name": "end_date_iso"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v88 = {
  "alias": "default_hour_cost",
  "args": null,
  "kind": "ScalarField",
  "name": "default_hour_cost_private",
  "storageKey": null
},
v89 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v19/*: any*/),
  (v88/*: any*/)
],
v90 = {
  "kind": "Literal",
  "name": "limit",
  "value": 1
},
v91 = {
  "kind": "Literal",
  "name": "where",
  "value": {
    "active": (v68/*: any*/),
    "is_placeholder": (v73/*: any*/)
  }
},
v92 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "model": {
        "_eq": "PROJECT"
      }
    }
  }
],
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "single_select",
  "storageKey": null
},
v95 = {
  "alias": "options",
  "args": null,
  "concreteType": "custom_select_options",
  "kind": "LinkedField",
  "name": "custom_select_options",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v96 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v93/*: any*/),
  (v94/*: any*/),
  (v95/*: any*/)
],
v97 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "model": {
        "_eq": "PERSON"
      }
    }
  }
],
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterable_in_planner",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sort_order",
  "storageKey": null
},
v100 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v66/*: any*/),
  (v98/*: any*/),
  (v99/*: any*/),
  (v17/*: any*/)
],
v101 = {
  "alias": "singleSelect",
  "args": null,
  "kind": "ScalarField",
  "name": "single_select",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v103 = [
  (v13/*: any*/),
  (v74/*: any*/)
],
v104 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v66/*: any*/),
  (v98/*: any*/)
],
v105 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v93/*: any*/),
  (v54/*: any*/)
],
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PlannerContainerQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ServerFlagsProvider_gql"
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Billing",
        "kind": "LinkedField",
        "name": "billing",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitlementsProvider_billing"
          }
        ],
        "storageKey": "billing(syncSubscription:false)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "users",
        "kind": "LinkedField",
        "name": "current_user",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "PageManager_user"
          },
          {
            "args": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectPlannerList_user"
          },
          {
            "args": (v10/*: any*/),
            "kind": "FragmentSpread",
            "name": "PeoplePlannerList_user"
          },
          {
            "args": (v11/*: any*/),
            "kind": "FragmentSpread",
            "name": "PersonSummaryRow_user"
          },
          {
            "args": (v11/*: any*/),
            "kind": "FragmentSpread",
            "name": "PlaceholderSummaryRow_user"
          },
          {
            "args": (v11/*: any*/),
            "kind": "FragmentSpread",
            "name": "PersonDetails_user"
          },
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "PersonAddProjectRow_user"
          },
          {
            "args": (v11/*: any*/),
            "kind": "FragmentSpread",
            "name": "Overbookings_user"
          },
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "SuperSearch_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuperSearchConfig_user"
          },
          {
            "args": (v10/*: any*/),
            "kind": "FragmentSpread",
            "name": "ChartPanel_user"
          },
          {
            "args": (v10/*: any*/),
            "kind": "FragmentSpread",
            "name": "SplitScreenPanel_user"
          },
          {
            "args": [
              (v5/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "PersonSchedulePanel_user"
          },
          {
            "args": [
              (v5/*: any*/),
              (v9/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectSchedulePanel_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SplitScreenRole_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoleSelector_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PersonTagSelector_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SkillsSelector_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HolidaysGroupSelector_viewer"
          },
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "AccountWelcome_user"
          },
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "OnboardingDialog_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoleForm_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreatePersonForm_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PersonForm_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProjectForm_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProjectBudget_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateBulkProjectsForm_viewer"
          },
          {
            "args": (v12/*: any*/),
            "kind": "FragmentSpread",
            "name": "ExternalProjectMemberForm_viewer"
          },
          {
            "args": (v12/*: any*/),
            "kind": "FragmentSpread",
            "name": "SingleExternalProjectMemberForm_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ClientForm_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Timeline_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SelectPersonList_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FilterSetQuery_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PersonCustomEditor_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProjectCustomEditor_viewer"
          },
          {
            "args": (v12/*: any*/),
            "kind": "FragmentSpread",
            "name": "ModeMessage_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "User_Account_Integrations"
          },
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "ViewFieldsTooltip_user"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "accounts",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PlaceholderForm_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PermissionsProvider_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PhasesWrapper_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PlannerContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "features",
        "kind": "LinkedField",
        "name": "features",
        "plural": true,
        "selections": [
          (v13/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "features_accounts",
        "kind": "LinkedField",
        "name": "features_accounts",
        "plural": true,
        "selections": [
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "feature_id",
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Billing",
        "kind": "LinkedField",
        "name": "billing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingSubscription",
            "kind": "LinkedField",
            "name": "subscription",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInTrial",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingSubscriptionItem",
                "kind": "LinkedField",
                "name": "plan",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "itemPriceId",
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingSubscriptionEntitlement",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featureId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featureType",
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "billing(syncSubscription:false)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "users",
        "kind": "LinkedField",
        "name": "current_user",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "accounts",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "account_type",
                "storageKey": null
              },
              (v14/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "where",
                    "variableName": "projectsFilter"
                  }
                ],
                "concreteType": "projects",
                "kind": "LinkedField",
                "name": "projects",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "clients",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "account_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "accounts",
                        "kind": "LinkedField",
                        "name": "account",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v25/*: any*/),
                  (v14/*: any*/),
                  (v26/*: any*/),
                  (v19/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "custom_select_values",
                    "kind": "LinkedField",
                    "name": "custom_select_values",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v36/*: any*/),
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "project_managers",
                    "kind": "LinkedField",
                    "name": "managers",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v39/*: any*/),
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "project_members",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "people",
                        "kind": "LinkedField",
                        "name": "person",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v19/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v52/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "project_workstreams",
                    "kind": "LinkedField",
                    "name": "project_workstreams",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "workstreams",
                        "kind": "LinkedField",
                        "name": "workstream",
                        "plural": false,
                        "selections": (v55/*: any*/),
                        "storageKey": null
                      },
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priority",
                    "storageKey": null
                  },
                  (v56/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calc_start_date",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calc_end_date",
                    "storageKey": null
                  },
                  (v58/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pricing_model_readable",
                    "storageKey": null
                  },
                  (v59/*: any*/),
                  (v60/*: any*/),
                  (v61/*: any*/),
                  {
                    "alias": "total_budget",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total_budget_private",
                    "storageKey": null
                  },
                  {
                    "alias": "expenses_budget",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expenses_budget_private",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emoji",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "project_roles",
                    "kind": "LinkedField",
                    "name": "project_roles",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v45/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimated_minutes",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v63/*: any*/),
                  (v65/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "project_links",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": true,
                    "selections": (v67/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "future_assignments_aggregate",
                    "args": [
                      {
                        "fields": [
                          {
                            "fields": [
                              {
                                "kind": "Variable",
                                "name": "_gte",
                                "variableName": "todaysDate"
                              }
                            ],
                            "kind": "ObjectValue",
                            "name": "end_date_iso"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "where"
                      }
                    ],
                    "concreteType": "assignments_aggregate",
                    "kind": "LinkedField",
                    "name": "assignments_aggregate",
                    "plural": false,
                    "selections": (v64/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v69/*: any*/),
                    "concreteType": "ext_project_link",
                    "kind": "LinkedField",
                    "name": "ext_project_links",
                    "plural": true,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ext_project_id",
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      {
                        "alias": "external_id",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ext_project_id",
                        "storageKey": null
                      },
                      {
                        "alias": "external",
                        "args": null,
                        "concreteType": "ext_project",
                        "kind": "LinkedField",
                        "name": "ext_project",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v70/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "remote_url",
                            "storageKey": null
                          },
                          (v71/*: any*/),
                          (v72/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ext_project",
                        "kind": "LinkedField",
                        "name": "ext_project",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "where",
                                "value": {
                                  "deleted": (v73/*: any*/)
                                }
                              }
                            ],
                            "concreteType": "ext_project_member",
                            "kind": "LinkedField",
                            "name": "ext_project_members",
                            "plural": true,
                            "selections": [
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ext_person",
                                "kind": "LinkedField",
                                "name": "ext_person",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v50/*: any*/),
                                  (v51/*: any*/),
                                  (v74/*: any*/),
                                  (v49/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v69/*: any*/),
                                    "concreteType": "ext_person_link",
                                    "kind": "LinkedField",
                                    "name": "ext_person_links",
                                    "plural": true,
                                    "selections": [
                                      (v75/*: any*/),
                                      (v44/*: any*/),
                                      (v19/*: any*/)
                                    ],
                                    "storageKey": "ext_person_links(where:{\"active\":{\"_eq\":true}})"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "ext_project_members(where:{\"deleted\":{\"_eq\":false}})"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "integration",
                            "kind": "LinkedField",
                            "name": "integration",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "integration_service",
                                "kind": "LinkedField",
                                "name": "integration_service",
                                "plural": false,
                                "selections": (v24/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "ext_project_links(where:{\"active\":{\"_eq\":true}})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "notes_aggregate",
                    "kind": "LinkedField",
                    "name": "notes_aggregate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "notes_aggregate_fields",
                        "kind": "LinkedField",
                        "name": "aggregate",
                        "plural": false,
                        "selections": (v62/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "milestones",
                    "kind": "LinkedField",
                    "name": "milestones",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      {
                        "alias": "date",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date_runn",
                        "storageKey": null
                      },
                      (v76/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v77/*: any*/),
                  (v78/*: any*/),
                  {
                    "alias": "isTemplate",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "is_template",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "order_by",
                        "value": {
                          "created_at": "asc"
                        }
                      }
                    ],
                    "concreteType": "notes",
                    "kind": "LinkedField",
                    "name": "notes",
                    "plural": true,
                    "selections": (v80/*: any*/),
                    "storageKey": "notes(order_by:{\"created_at\":\"asc\"})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "phases",
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      (v81/*: any*/),
                      (v82/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": "revenue_budget",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "revenue_budget_private",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "budget_method",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "where",
                    "variableName": "peopleFilter"
                  }
                ],
                "concreteType": "people",
                "kind": "LinkedField",
                "name": "people",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v74/*: any*/),
                  (v49/*: any*/),
                  (v28/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "project_members",
                    "kind": "LinkedField",
                    "name": "project_memberships",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v47/*: any*/),
                      (v53/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "projects",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v29/*: any*/),
                          (v26/*: any*/),
                          (v19/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/),
                      (v45/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "has_assignments",
                        "storageKey": null
                      },
                      (v60/*: any*/),
                      (v49/*: any*/),
                      (v48/*: any*/),
                      (v44/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "person_requests",
                    "kind": "LinkedField",
                    "name": "person_requests",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      (v47/*: any*/),
                      (v79/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "users",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role_name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "people",
                        "kind": "LinkedField",
                        "name": "person",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v50/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "contracts",
                            "kind": "LinkedField",
                            "name": "contracts",
                            "plural": true,
                            "selections": [
                              (v13/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "roles",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "competencies",
                    "kind": "LinkedField",
                    "name": "competencies",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "level",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "skills",
                        "kind": "LinkedField",
                        "name": "skill",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "contracts",
                    "kind": "LinkedField",
                    "name": "current_contract",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v85/*: any*/),
                      (v52/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "custom_select_values",
                    "kind": "LinkedField",
                    "name": "custom_select_values",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v34/*: any*/),
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v36/*: any*/),
                  (v38/*: any*/),
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people_managers",
                    "kind": "LinkedField",
                    "name": "managers",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v39/*: any*/),
                      (v86/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v87/*: any*/),
                    "concreteType": "assignments",
                    "kind": "LinkedField",
                    "name": "assignments",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v81/*: any*/),
                      (v82/*: any*/),
                      (v84/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "non_working_day",
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      (v46/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "is_billable",
                        "storageKey": null
                      },
                      (v76/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phase_id",
                        "storageKey": null
                      },
                      (v79/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "projects",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "contracts",
                    "kind": "LinkedField",
                    "name": "contracts",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v81/*: any*/),
                      (v82/*: any*/),
                      (v84/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rostered_days",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employment_type",
                        "storageKey": null
                      },
                      (v83/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "roles",
                        "kind": "LinkedField",
                        "name": "role",
                        "plural": false,
                        "selections": (v89/*: any*/),
                        "storageKey": null
                      },
                      (v85/*: any*/),
                      (v45/*: any*/),
                      {
                        "alias": "padded_cost",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cost_padded_private",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "permanent",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v87/*: any*/),
                    "concreteType": "time_offs",
                    "kind": "LinkedField",
                    "name": "time_offs",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v81/*: any*/),
                      (v82/*: any*/),
                      (v84/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "leave_type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v69/*: any*/),
                        "concreteType": "ext_time_off_link",
                        "kind": "LinkedField",
                        "name": "ext_time_off_links",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "time_off_id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ext_time_off_id",
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          {
                            "alias": "external_id",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ext_time_off_id",
                            "storageKey": null
                          },
                          {
                            "alias": "external",
                            "args": null,
                            "concreteType": "ext_time_off",
                            "kind": "LinkedField",
                            "name": "ext_time_off",
                            "plural": false,
                            "selections": [
                              (v70/*: any*/),
                              (v13/*: any*/),
                              (v72/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "ext_time_off_links(where:{\"active\":{\"_eq\":true}})"
                      },
                      (v44/*: any*/),
                      (v76/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v58/*: any*/),
                  (v19/*: any*/),
                  (v61/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "holidays_groups",
                    "kind": "LinkedField",
                    "name": "holidays_group",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  (v65/*: any*/),
                  (v63/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people_links",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": true,
                    "selections": (v67/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v69/*: any*/),
                    "concreteType": "ext_person_link",
                    "kind": "LinkedField",
                    "name": "ext_person_links",
                    "plural": true,
                    "selections": [
                      (v44/*: any*/),
                      (v75/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": "external_id",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ext_person_id",
                        "storageKey": null
                      },
                      {
                        "alias": "external",
                        "args": null,
                        "concreteType": "ext_person",
                        "kind": "LinkedField",
                        "name": "ext_person",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v70/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v74/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "ext_person_links(where:{\"active\":{\"_eq\":true}})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people_notes",
                    "kind": "LinkedField",
                    "name": "people_notes",
                    "plural": true,
                    "selections": (v80/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "placeholder_suggestions",
                    "kind": "LinkedField",
                    "name": "placeholder_suggestions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "suggested_person_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "people",
                        "kind": "LinkedField",
                        "name": "suggested_person",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people_notes_aggregate",
                    "kind": "LinkedField",
                    "name": "people_notes_aggregate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "people_notes_aggregate_fields",
                        "kind": "LinkedField",
                        "name": "aggregate",
                        "plural": false,
                        "selections": (v62/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v59/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "accounts",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              (v25/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "rate_cards",
                "kind": "LinkedField",
                "name": "rate_cards",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "role_charge_out_rates",
                    "kind": "LinkedField",
                    "name": "role_charge_out_rates",
                    "plural": true,
                    "selections": [
                      (v45/*: any*/),
                      (v78/*: any*/),
                      (v52/*: any*/),
                      {
                        "alias": "charge_out_rate",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "charge_out_rate_private",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  {
                    "alias": "blended_rate",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blended_rate_private",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blended_rate_card",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "roles",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v19/*: any*/),
                  (v88/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      (v90/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "order_by",
                        "value": {
                          "created_at": "desc"
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "person": {
                            "is_placeholder": (v68/*: any*/)
                          }
                        }
                      }
                    ],
                    "concreteType": "contracts",
                    "kind": "LinkedField",
                    "name": "contracts",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "people",
                        "kind": "LinkedField",
                        "name": "person",
                        "plural": false,
                        "selections": [
                          (v50/*: any*/),
                          (v51/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "placeholder_count",
                            "storageKey": null
                          },
                          (v57/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "contracts(limit:1,order_by:{\"created_at\":\"desc\"},where:{\"person\":{\"is_placeholder\":{\"_eq\":true}}})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v91/*: any*/)
                ],
                "concreteType": "people_aggregate",
                "kind": "LinkedField",
                "name": "people_aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people_aggregate_fields",
                    "kind": "LinkedField",
                    "name": "aggregate",
                    "plural": false,
                    "selections": (v62/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": "people_aggregate(where:{\"active\":{\"_eq\":true},\"is_placeholder\":{\"_eq\":false}})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "workstreams",
                "kind": "LinkedField",
                "name": "workstreams",
                "plural": true,
                "selections": (v55/*: any*/),
                "storageKey": null
              },
              {
                "alias": "project_custom_select_types",
                "args": (v92/*: any*/),
                "concreteType": "custom_select_types",
                "kind": "LinkedField",
                "name": "custom_select_types",
                "plural": true,
                "selections": (v96/*: any*/),
                "storageKey": "custom_select_types(where:{\"model\":{\"_eq\":\"PROJECT\"}})"
              },
              {
                "alias": "people_custom_select_types",
                "args": (v97/*: any*/),
                "concreteType": "custom_select_types",
                "kind": "LinkedField",
                "name": "custom_select_types",
                "plural": true,
                "selections": (v96/*: any*/),
                "storageKey": "custom_select_types(where:{\"model\":{\"_eq\":\"PERSON\"}})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondary_person_field",
                "storageKey": null
              },
              {
                "alias": "custom_text_types_person",
                "args": (v97/*: any*/),
                "concreteType": "custom_text_types",
                "kind": "LinkedField",
                "name": "custom_text_types",
                "plural": true,
                "selections": (v100/*: any*/),
                "storageKey": "custom_text_types(where:{\"model\":{\"_eq\":\"PERSON\"}})"
              },
              {
                "alias": "custom_select_types_person",
                "args": (v97/*: any*/),
                "concreteType": "custom_select_types",
                "kind": "LinkedField",
                "name": "custom_select_types",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v95/*: any*/),
                  (v66/*: any*/),
                  (v98/*: any*/),
                  (v99/*: any*/),
                  (v101/*: any*/),
                  (v93/*: any*/),
                  (v102/*: any*/),
                  (v94/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": "custom_select_types(where:{\"model\":{\"_eq\":\"PERSON\"}})"
              },
              {
                "alias": "custom_checkbox_types_person",
                "args": (v97/*: any*/),
                "concreteType": "custom_checkbox_types",
                "kind": "LinkedField",
                "name": "custom_checkbox_types",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v17/*: any*/),
                  (v66/*: any*/),
                  (v98/*: any*/),
                  (v99/*: any*/)
                ],
                "storageKey": "custom_checkbox_types(where:{\"model\":{\"_eq\":\"PERSON\"}})"
              },
              {
                "alias": "custom_date_types_person",
                "args": (v97/*: any*/),
                "concreteType": "custom_date_types",
                "kind": "LinkedField",
                "name": "custom_date_types",
                "plural": true,
                "selections": (v100/*: any*/),
                "storageKey": "custom_date_types(where:{\"model\":{\"_eq\":\"PERSON\"}})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "business_days",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "users",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": (v103/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "invitations",
                "kind": "LinkedField",
                "name": "invitations",
                "plural": true,
                "selections": (v103/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "state": {
                        "_neq": "PENDING"
                      }
                    }
                  }
                ],
                "concreteType": "integration",
                "kind": "LinkedField",
                "name": "integrationsV2",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "integration_service",
                    "kind": "LinkedField",
                    "name": "integration_service",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "square_image_url",
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "integrationsV2(where:{\"state\":{\"_neq\":\"PENDING\"}})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_select_types",
                "kind": "LinkedField",
                "name": "custom_select_types",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v93/*: any*/),
                  (v95/*: any*/),
                  (v66/*: any*/),
                  (v98/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "custom_select_options",
                    "kind": "LinkedField",
                    "name": "custom_select_options",
                    "plural": true,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "custom_text_types_project",
                "args": (v92/*: any*/),
                "concreteType": "custom_text_types",
                "kind": "LinkedField",
                "name": "custom_text_types",
                "plural": true,
                "selections": (v100/*: any*/),
                "storageKey": "custom_text_types(where:{\"model\":{\"_eq\":\"PROJECT\"}})"
              },
              {
                "alias": "custom_date_types_project",
                "args": (v92/*: any*/),
                "concreteType": "custom_date_types",
                "kind": "LinkedField",
                "name": "custom_date_types",
                "plural": true,
                "selections": (v100/*: any*/),
                "storageKey": "custom_date_types(where:{\"model\":{\"_eq\":\"PROJECT\"}})"
              },
              {
                "alias": "custom_select_types_project",
                "args": (v92/*: any*/),
                "concreteType": "custom_select_types",
                "kind": "LinkedField",
                "name": "custom_select_types",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v95/*: any*/),
                  (v66/*: any*/),
                  (v98/*: any*/),
                  (v93/*: any*/),
                  (v102/*: any*/),
                  (v101/*: any*/),
                  (v99/*: any*/),
                  (v94/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": "custom_select_types(where:{\"model\":{\"_eq\":\"PROJECT\"}})"
              },
              {
                "alias": "custom_checkbox_types_project",
                "args": (v92/*: any*/),
                "concreteType": "custom_checkbox_types",
                "kind": "LinkedField",
                "name": "custom_checkbox_types",
                "plural": true,
                "selections": (v100/*: any*/),
                "storageKey": "custom_checkbox_types(where:{\"model\":{\"_eq\":\"PROJECT\"}})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "teams",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_text_types",
                "kind": "LinkedField",
                "name": "custom_text_types",
                "plural": true,
                "selections": (v104/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_date_types",
                "kind": "LinkedField",
                "name": "custom_date_types",
                "plural": true,
                "selections": (v104/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_checkbox_types",
                "kind": "LinkedField",
                "name": "custom_checkbox_types",
                "plural": true,
                "selections": (v104/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "clients",
                "kind": "LinkedField",
                "name": "clients",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v19/*: any*/),
                  (v22/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "skills",
                "kind": "LinkedField",
                "name": "skills",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "tags",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": (v105/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "user_accounts",
                "kind": "LinkedField",
                "name": "user_accounts",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v106/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "users",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v106/*: any*/),
                      (v74/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "people_tags",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "model": {
                        "_eq": "person"
                      }
                    }
                  }
                ],
                "concreteType": "tags",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": (v105/*: any*/),
                "storageKey": "tags(where:{\"model\":{\"_eq\":\"person\"}})"
              },
              {
                "alias": "allSkills",
                "args": null,
                "concreteType": "skills",
                "kind": "LinkedField",
                "name": "skills",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "order_by",
                    "value": {
                      "name": "asc"
                    }
                  }
                ],
                "concreteType": "holidays_groups",
                "kind": "LinkedField",
                "name": "holidays_groups",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "holidays_groups(order_by:{\"name\":\"asc\"})"
              },
              {
                "alias": "all_roles",
                "args": null,
                "concreteType": "roles",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": (v89/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subscription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "use_week_numbers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billing_method",
                "storageKey": null
              },
              {
                "alias": "project_tags",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "model": {
                        "_eq": "project"
                      }
                    }
                  }
                ],
                "concreteType": "tags",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": (v55/*: any*/),
                "storageKey": "tags(where:{\"model\":{\"_eq\":\"project\"}})"
              },
              {
                "alias": "projectTemplates",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "is_template": (v68/*: any*/)
                    }
                  }
                ],
                "concreteType": "projects",
                "kind": "LinkedField",
                "name": "projects",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v28/*: any*/),
                  (v56/*: any*/),
                  (v19/*: any*/),
                  (v27/*: any*/),
                  (v77/*: any*/),
                  (v78/*: any*/),
                  (v59/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "custom_text_values",
                    "kind": "LinkedField",
                    "name": "custom_text_values",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "custom_select_values",
                    "kind": "LinkedField",
                    "name": "custom_select_values",
                    "plural": true,
                    "selections": [
                      (v34/*: any*/),
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "custom_checkbox_values",
                    "kind": "LinkedField",
                    "name": "custom_checkbox_values",
                    "plural": true,
                    "selections": [
                      (v37/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "custom_date_values",
                    "kind": "LinkedField",
                    "name": "custom_date_values",
                    "plural": true,
                    "selections": [
                      (v42/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "project_members",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v44/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(where:{\"is_template\":{\"_eq\":true}})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ext_project",
                "kind": "LinkedField",
                "name": "ext_projects",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": "custom_date_types_projects",
                "args": (v92/*: any*/),
                "concreteType": "custom_date_types",
                "kind": "LinkedField",
                "name": "custom_date_types",
                "plural": true,
                "selections": (v40/*: any*/),
                "storageKey": "custom_date_types(where:{\"model\":{\"_eq\":\"PROJECT\"}})"
              },
              {
                "alias": "real_active_people",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "order_by",
                    "value": {
                      "first_name": "asc",
                      "last_name": "asc"
                    }
                  },
                  (v91/*: any*/)
                ],
                "concreteType": "people",
                "kind": "LinkedField",
                "name": "people",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v74/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": "people(order_by:{\"first_name\":\"asc\",\"last_name\":\"asc\"},where:{\"active\":{\"_eq\":true},\"is_placeholder\":{\"_eq\":false}})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timesheets_protected",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewed_welcome",
            "storageKey": null
          },
          (v50/*: any*/),
          (v51/*: any*/),
          (v74/*: any*/),
          (v106/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "favourite_projects",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "favourite_people",
            "storageKey": null
          },
          {
            "alias": "favouritePersonIds",
            "args": null,
            "kind": "ScalarField",
            "name": "favourite_people",
            "storageKey": null
          },
          (v20/*: any*/),
          {
            "alias": null,
            "args": [
              (v90/*: any*/)
            ],
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "people",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v74/*: any*/),
              (v20/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": "people(limit:1)"
          },
          {
            "alias": "favouriteProjectIds",
            "args": null,
            "kind": "ScalarField",
            "name": "favourite_projects",
            "storageKey": null
          },
          {
            "alias": "userId",
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "views",
            "kind": "LinkedField",
            "name": "view",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "people_filters",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "project_filters",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "user_filter_sets",
            "kind": "LinkedField",
            "name": "filter_sets",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filters",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_managers",
            "kind": "LinkedField",
            "name": "manageable_projects",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "people_managers",
            "kind": "LinkedField",
            "name": "manageable_people",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v86/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "linkedPerson",
            "plural": false,
            "selections": (v40/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d88636f25c6b3e69d85589c4342deb75",
    "id": null,
    "metadata": {},
    "name": "PlannerContainerQuery",
    "operationKind": "query",
    "text": "query PlannerContainerQuery(\n  $todaysDate: date!\n  $plannerStartDate: date!\n  $projectsFilter: projects_bool_exp\n  $peopleFilter: people_bool_exp\n) {\n  ...ServerFlagsProvider_gql\n  billing(syncSubscription: false) {\n    ...EntitlementsProvider_billing\n  }\n  current_user {\n    ...PageManager_user_3WSZHA\n    ...ProjectPlannerList_user_4bzbde\n    ...PeoplePlannerList_user_3aMKBZ\n    ...PersonSummaryRow_user_2UVESh\n    ...PlaceholderSummaryRow_user_2UVESh\n    ...PersonDetails_user_2UVESh\n    ...PersonAddProjectRow_user_3WSZHA\n    ...Overbookings_user_2UVESh\n    ...SuperSearch_user_3WSZHA\n    ...SuperSearchConfig_user\n    ...ChartPanel_user_3aMKBZ\n    ...SplitScreenPanel_user_3aMKBZ\n    ...PersonSchedulePanel_user_1dOjVc\n    ...ProjectSchedulePanel_user_Mki9X\n    ...SplitScreenRole_user\n    ...RoleSelector_user\n    ...PersonTagSelector_user\n    ...SkillsSelector_viewer\n    ...HolidaysGroupSelector_viewer\n    ...AccountWelcome_user_3WSZHA\n    ...OnboardingDialog_user_3WSZHA\n    ...RoleForm_viewer\n    ...CreatePersonForm_viewer\n    ...PersonForm_viewer\n    ...ProjectForm_viewer\n    ...ProjectBudget_viewer\n    ...CreateBulkProjectsForm_viewer\n    ...ExternalProjectMemberForm_viewer_1zMQSI\n    ...SingleExternalProjectMemberForm_viewer_1zMQSI\n    ...ClientForm_viewer\n    ...Timeline_user\n    ...SelectPersonList_user\n    ...FilterSetQuery_user\n    ...PersonCustomEditor_viewer\n    ...ProjectCustomEditor_viewer\n    ...ModeMessage_viewer_1zMQSI\n    ...User_Account_Integrations\n    ...ViewFieldsTooltip_user_3WSZHA\n    account {\n      id\n      name\n      default_full_time_minutes\n    }\n    ...PlaceholderForm_user\n    ...PermissionsProvider_user\n    ...PhasesWrapper_user\n  }\n}\n\nfragment AccountWelcome_user_3WSZHA on users {\n  id\n  account {\n    account_type\n    name\n  }\n  viewed_welcome\n  ...WelcomeVideoDialog_user\n  ...OnboardingDialog_user_3WSZHA\n}\n\nfragment Account_Integrations on accounts {\n  integrationsV2(where: {state: {_neq: \"PENDING\"}}) {\n    id\n    integration_service {\n      id\n      square_image_url\n      name\n    }\n  }\n}\n\nfragment AddPersonToProject_account_1O2T5R on accounts {\n  id\n  projects(where: $projectsFilter) {\n    id\n    name\n    team_id\n    emoji\n    is_template\n    client {\n      id\n      name\n      image_key\n      website\n    }\n    members {\n      id\n      person_id\n      project_id\n      role_id\n      workstream_id\n      is_placeholder\n    }\n    project_workstreams {\n      workstream {\n        id\n        name\n        archived\n      }\n    }\n  }\n  ...SelectPersonList_account_3aMKBZ\n}\n\nfragment AddProjectToPerson_user_3WSZHA on users {\n  id\n  favourite_projects\n  account {\n    id\n    secondary_person_field\n    projects(where: $projectsFilter) {\n      id\n      name\n      confirmed\n      team_id\n      active\n      is_template\n      emoji\n      tags\n      pricing_model\n      client {\n        id\n        name\n        image_key\n        website\n      }\n      members {\n        id\n        project_id\n        person_id\n        role_id\n        workstream_id\n      }\n      managers {\n        id\n        user_id\n      }\n      team {\n        id\n        name\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        value\n        custom_checkbox_type_id\n      }\n      project_workstreams {\n        workstream {\n          id\n          name\n          archived\n        }\n      }\n    }\n    people(where: $peopleFilter) {\n      id\n      first_name\n      last_name\n      email\n      image_key\n      is_placeholder\n      tags\n      time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        person_id\n        minutes_per_day\n        ext_time_off_links(where: {active: {_eq: true}}) {\n          time_off_id\n          ext_time_off_id\n          active\n          external_id: ext_time_off_id\n          external: ext_time_off {\n            __typename\n            id\n            integration_id\n          }\n        }\n      }\n      current_contract {\n        id\n        job_title\n      }\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n        job_title\n        role {\n          id\n          name\n          active\n        }\n      }\n      team {\n        id\n        name\n      }\n      competencies {\n        id\n        level\n        skill {\n          id\n          name\n        }\n      }\n      project_memberships {\n        id\n        project_id\n      }\n      person_requests {\n        id\n        status\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        value\n        custom_checkbox_type_id\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      managers {\n        id\n        user_id\n      }\n    }\n    roles {\n      id\n      name\n      active\n    }\n  }\n}\n\nfragment AddTimeOffModal_account on accounts {\n  ...PlannerDatePicker_account\n}\n\nfragment AssignmentActionPill_account on accounts {\n  default_full_time_minutes\n  ...PlannerDatePicker_account\n}\n\nfragment CapacityIndicator_account on accounts {\n  default_full_time_minutes\n}\n\nfragment ChangeProjectRoleModal_person on people {\n  id\n  first_name\n  last_name\n  project_memberships {\n    id\n    role_id\n    workstream_id\n    project_id\n    has_assignments\n    has_actuals\n  }\n}\n\nfragment ChangeProjectRoleModal_project on projects {\n  id\n  name\n  members {\n    id\n    role_id\n  }\n}\n\nfragment ChangeProjectRoleModal_roles on roles {\n  id\n  name\n  active\n}\n\nfragment ChangeWorkstreamModal_person on people {\n  id\n  first_name\n  last_name\n  project_memberships {\n    id\n    role_id\n    workstream_id\n    project_id\n    has_assignments\n    has_actuals\n  }\n}\n\nfragment ChangeWorkstreamModal_project on projects {\n  id\n  name\n  project_workstreams {\n    workstream {\n      id\n      name\n      archived\n    }\n  }\n}\n\nfragment ChartPanel_user_3aMKBZ on users {\n  id\n  favourite_people\n  favourite_projects\n  account {\n    id\n    default_full_time_minutes\n    projects(where: $projectsFilter) {\n      id\n      name\n      active\n      confirmed\n      is_template\n      client {\n        id\n        name\n      }\n      team {\n        id\n        name\n      }\n      tags\n      members {\n        id\n        person_id\n        role_id\n        workstream_id\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        value\n        custom_checkbox_type_id\n      }\n      managers {\n        id\n        user_id\n      }\n      pricing_model\n      project_workstreams {\n        workstream {\n          id\n        }\n      }\n    }\n    people(where: $peopleFilter) {\n      id\n      is_placeholder\n      first_name\n      last_name\n      email\n      active\n      tags\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        employment_type\n        minutes_per_day\n        cost: cost_private\n        padded_cost: cost_padded_private\n        permanent\n        rostered_days\n        role_id\n        job_title\n        role {\n          id\n          name\n        }\n      }\n      team {\n        id\n        name\n      }\n      time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        person_id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        leave_type\n        minutes_per_day\n        ext_time_off_links(where: {active: {_eq: true}}) {\n          time_off_id\n          ext_time_off_id\n          active\n          external_id: ext_time_off_id\n          external: ext_time_off {\n            __typename\n            id\n            integration_id\n          }\n        }\n      }\n      assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n        is_billable\n        project_id\n        person_id\n        role_id\n        non_working_day\n      }\n      project_memberships {\n        id\n        project_id\n      }\n      competencies {\n        id\n        level\n        skill {\n          id\n          name\n        }\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        custom_checkbox_type_id\n        value\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      person_requests {\n        id\n        status\n        updated_at\n      }\n      managers {\n        id\n        user_id\n      }\n    }\n  }\n}\n\nfragment ClientForm_viewer on users {\n  account {\n    id\n    name\n    clients {\n      id\n      active\n      name\n    }\n  }\n}\n\nfragment ConfirmContractForm_person on people {\n  id\n  email\n}\n\nfragment ContractsTooltip_person on people {\n  id\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n  }\n  ...PersonSidePanel_person\n}\n\nfragment CreateBulkPeopleForm_user on users {\n  id\n  permissions\n  account {\n    id\n    roles {\n      id\n      name\n      active\n    }\n    people_aggregate(where: {active: {_eq: true}, is_placeholder: {_eq: false}}) {\n      aggregate {\n        count\n      }\n    }\n  }\n}\n\nfragment CreateBulkProjectsForm_viewer on users {\n  id\n  permissions\n  account {\n    name\n    billing_method\n    clients {\n      id\n      name\n      image_key\n      website\n      internal\n      real_client\n    }\n  }\n}\n\nfragment CreatePersonForm_viewer on users {\n  account {\n    id\n    subscription\n    people_aggregate(where: {active: {_eq: true}, is_placeholder: {_eq: false}}) {\n      aggregate {\n        count\n      }\n    }\n  }\n  ...CreateBulkPeopleForm_user\n}\n\nfragment CreateProjectFromTemplateForm_project on projects {\n  id\n  name\n  tags\n  workstreams_computed\n  pricing_model\n  client_id\n  rate_card_id\n  team_id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  ...ProjectCustomEditor_project\n}\n\nfragment CreateTemplateFromProjectForm_project on projects {\n  id\n  name\n  tags\n  workstreams_computed\n  active\n  pricing_model\n  client_id\n  rate_card_id\n  team_id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  ...ProjectCustomEditor_project\n}\n\nfragment CustomFieldSectionHeaderPerson_account on accounts {\n  custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n  }\n  custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n  }\n  custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n  }\n  custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n  }\n}\n\nfragment CustomFieldSectionHeaderProject_account on accounts {\n  custom_text_types_project: custom_text_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n  }\n  custom_date_types_projects: custom_date_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n  }\n  custom_select_types_project: custom_select_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n  }\n  custom_checkbox_types_project: custom_checkbox_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n  }\n}\n\nfragment DetectedPeopleSection_account_1zMQSI on accounts {\n  id\n  ...ProjectGroupRow_account_1zMQSI\n}\n\nfragment DetectedPeopleSection_project on projects {\n  id\n  members {\n    id\n    person_id\n  }\n  ...ProjectGroupRow_project\n  ...ProjectDetailsDetectedPersonRow_project\n  ...DetectedPersonRows_project\n  ext_project_links(where: {active: {_eq: true}}) {\n    ext_project_id\n    project_id\n    ext_project {\n      id\n      integration {\n        id\n        integration_service {\n          id\n          name\n        }\n      }\n      ext_project_members(where: {deleted: {_eq: false}}) {\n        id\n        ext_person {\n          id\n          first_name\n          last_name\n          email\n          is_placeholder\n          active\n          ext_person_links(where: {active: {_eq: true}}) {\n            ext_person_id\n            person_id\n            active\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DetectedPeopleSection_user on users {\n  ...DetectedPersonRows_user\n}\n\nfragment DetectedPersonRows_project on projects {\n  id\n  members {\n    id\n    person_id\n  }\n  ...ProjectDetailsDetectedPersonRow_project\n  ext_project_links(where: {active: {_eq: true}}) {\n    ext_project_id\n    project_id\n    ext_project {\n      id\n      ext_project_members(where: {deleted: {_eq: false}}) {\n        id\n        ext_person {\n          id\n          ...ProjectDetailsDetectedPersonRow_extPerson\n          ext_person_links(where: {active: {_eq: true}}) {\n            ext_person_id\n            person_id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DetectedPersonRows_user on users {\n  id\n  ...ProjectDetailsPersonRow_user\n  ...ProjectDetailsDetectedPersonRow_user\n  account {\n    id\n    ...ProjectDetailsDetectedPersonRow_account\n    people(where: $peopleFilter) {\n      ...ProjectDetailsPersonRow_person_EEkLV\n    }\n  }\n}\n\nfragment DragToCreateOutline_account on accounts {\n  ...PlannerDatePicker_account\n}\n\nfragment EditPersonForm_person on people {\n  id\n  first_name\n  last_name\n  managers {\n    id\n    user_id\n    person {\n      id\n    }\n  }\n  email\n  image_key\n  tags\n  references\n  active\n  archivable\n  team {\n    name\n    id\n  }\n  contracts {\n    id\n    rostered_days\n    employment_type\n    minutes_per_day\n    cost: cost_private\n    start_date: start_date_runn\n    end_date: end_date_runn\n    role {\n      id\n      name\n      active\n    }\n    job_title\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  holidays_group {\n    id\n    name\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  ...PersonCustomEditor_person\n  ...ExtLinks_Person\n  ...PersonActionButtons_person\n  ...ConfirmContractForm_person\n}\n\nfragment EditPersonForm_user on users {\n  id\n  ...PersonActionButtons_user\n}\n\nfragment EditProjectForm_project on projects {\n  id\n  name\n  managers {\n    id\n    user_id\n    project {\n      id\n    }\n  }\n  tags\n  workstreams_computed\n  confirmed\n  active\n  pricing_model\n  references\n  client_id\n  rate_card_id\n  team_id\n  is_template\n  emoji\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  members {\n    id\n    project_id\n    workstream_id\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  ...ProjectCustomEditor_project\n  ...ExtLinks_Project\n}\n\nfragment EffortInput_account on accounts {\n  ...FTEInput_account\n}\n\nfragment EntitlementsProvider_billing on Billing {\n  subscription {\n    id\n    isInTrial\n    plan {\n      itemPriceId\n      id\n    }\n  }\n  entitlements {\n    featureId\n    featureType\n    value\n  }\n}\n\nfragment ExtLinks_Person on people {\n  ext_person_links(where: {active: {_eq: true}}) {\n    person_id\n    ext_person_id\n    active\n    external_id: ext_person_id\n    external: ext_person {\n      id\n      __typename\n      first_name\n      last_name\n      email\n      remote_id\n      integration_id\n    }\n  }\n}\n\nfragment ExtLinks_Project on projects {\n  ext_project_links(where: {active: {_eq: true}}) {\n    project_id\n    ext_project_id\n    active\n    external_id: ext_project_id\n    external: ext_project {\n      id\n      __typename\n      name\n      remote_url\n      remote_id\n      integration_id\n    }\n  }\n}\n\nfragment ExternalProjectMemberForm_viewer_1zMQSI on users {\n  account {\n    id\n    people(where: $peopleFilter) {\n      id\n      email\n      first_name\n      last_name\n      active\n      is_placeholder\n      contracts {\n        id\n        employment_type\n        minutes_per_day\n        start_date: start_date_runn\n        end_date: end_date_runn\n        role {\n          id\n          name\n        }\n      }\n    }\n    roles {\n      id\n      name\n    }\n    rate_cards {\n      id\n      name\n      active\n    }\n    clients {\n      id\n      active\n      name\n    }\n  }\n}\n\nfragment FTEInput_account on accounts {\n  default_full_time_minutes\n}\n\nfragment FilterSetQuery_user on users {\n  filter_sets {\n    id\n    type\n    name\n    filters\n  }\n}\n\nfragment FullPicker_account on accounts {\n  default_full_time_minutes\n  ...PlannerDatePickerHourStats_account\n  ...TimeOffEffortInputs_account\n}\n\nfragment HolidaysGroupSelector_viewer on users {\n  account {\n    id\n    holidays_groups(order_by: {name: asc}) {\n      id\n      name\n    }\n  }\n}\n\nfragment MiniPicker_account on accounts {\n  id\n  default_full_time_minutes\n  ...EffortInput_account\n  ...TotalEffortInput_account\n  ...NonWorkingDayInput_account\n}\n\nfragment ModeMessage_viewer_1zMQSI on users {\n  account {\n    id\n    people(where: $peopleFilter) {\n      id\n      first_name\n      last_name\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n      }\n    }\n    roles {\n      id\n      name\n    }\n    workstreams {\n      id\n      name\n    }\n  }\n}\n\nfragment NonWorkingDayInput_account on accounts {\n  ...FTEInput_account\n}\n\nfragment OnboardingDialog_user_3WSZHA on users {\n  id\n  first_name\n  last_name\n  email\n  account {\n    name\n    account_type\n    projects(where: $projectsFilter) {\n      id\n      client {\n        id\n      }\n    }\n    people(where: $peopleFilter) {\n      id\n      first_name\n      last_name\n    }\n    ...OnboardingFinancials_account_2UVESh\n  }\n  ...OnboardingPeople_user\n}\n\nfragment OnboardingFinancials_account_2UVESh on accounts {\n  id\n  currency\n  rate_type\n  default_full_time_minutes\n  projects(where: $projectsFilter) {\n    id\n    rate_type\n  }\n  rate_cards {\n    id\n    name\n    role_charge_out_rates {\n      role_id\n      rate_card_id\n      role {\n        id\n        name\n      }\n      charge_out_rate: charge_out_rate_private\n    }\n  }\n}\n\nfragment OnboardingPeople_user on users {\n  account {\n    id\n  }\n  ...CreateBulkPeopleForm_user\n}\n\nfragment Overbookings_person_EEkLV on people {\n  id\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    person_id\n    role_id\n    project_id\n    non_working_day\n    is_template\n    workstream_id\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n  }\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    leave_type\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n}\n\nfragment Overbookings_user_2UVESh on users {\n  account {\n    projects(where: $projectsFilter) {\n      id\n      confirmed\n    }\n  }\n}\n\nfragment PageControls_account_2UVESh on accounts {\n  id\n  ...ProjectPlannerOptions_account\n  ...PeoplePlannerOptions_account\n  ...TentativeProjectsToggle_account_2UVESh\n}\n\nfragment PageManager_user_3WSZHA on users {\n  ...AccountWelcome_user_3WSZHA\n  ...SelectViewDialog_user\n  account {\n    account_type\n    ...ProjectPlanner_account_2UVESh\n    ...PeoplePlanner_account_2UVESh\n  }\n}\n\nfragment PeoplePlannerList_user_3aMKBZ on users {\n  id\n  favourite_people\n  favourite_projects\n  account {\n    projects(where: $projectsFilter) {\n      id\n      name\n      active\n      confirmed\n      pricing_model\n      is_template\n      tags\n      client {\n        id\n        name\n      }\n      team {\n        id\n        name\n      }\n      members {\n        id\n        person_id\n        role_id\n        workstream_id\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        value\n        custom_checkbox_type_id\n      }\n      managers {\n        id\n        user_id\n      }\n      project_workstreams {\n        workstream {\n          id\n        }\n      }\n    }\n    people(where: $peopleFilter) {\n      id\n      is_placeholder\n      first_name\n      last_name\n      email\n      active\n      tags\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        employment_type\n        job_title\n        role {\n          id\n          name\n        }\n      }\n      team {\n        id\n        name\n      }\n      project_memberships {\n        id\n        project_id\n      }\n      assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        project_id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        project {\n          id\n          confirmed\n        }\n      }\n      competencies {\n        id\n        level\n        skill {\n          id\n          name\n        }\n      }\n      person_requests {\n        id\n        status\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        value\n        custom_checkbox_type_id\n      }\n      links {\n        id\n        name\n        href\n        show_in_planner\n      }\n      managers {\n        id\n        user_id\n      }\n    }\n    ...TimeOffSummary_account_1dOjVc\n    ...TimeOffSummaryCounter_account_1dOjVc\n  }\n  ...PersonManagement_user_3aMKBZ\n}\n\nfragment PeoplePlannerOptions_account on accounts {\n  workstreams {\n    id\n  }\n  people_custom_select_types: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    model\n    single_select\n    options: custom_select_options {\n      id\n      name\n    }\n  }\n}\n\nfragment PeoplePlanner_account_2UVESh on accounts {\n  ...PlannerHeader_account_2UVESh\n}\n\nfragment PermissionsProvider_user on users {\n  id\n  email\n  account {\n    id\n    timesheets_protected\n  }\n  permissions\n  manageable_projects {\n    id\n    project {\n      id\n    }\n  }\n  manageable_people {\n    id\n    person {\n      id\n    }\n  }\n  linkedPerson {\n    id\n  }\n}\n\nfragment PersonActionButtons_person on people {\n  id\n  is_placeholder\n  email\n  first_name\n  last_name\n  active\n  archivable\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n}\n\nfragment PersonActionButtons_user on users {\n  id\n  favourite_people\n  account {\n    id\n    users {\n      id\n      email\n    }\n    invitations {\n      id\n      email\n    }\n  }\n}\n\nfragment PersonAddProjectRow_person_EEkLV on people {\n  id\n  first_name\n  last_name\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    role {\n      name\n    }\n  }\n  project_memberships {\n    id\n    project_id\n    person_id\n    role_id\n    workstream_id\n    project {\n      is_template\n      confirmed\n      active\n    }\n  }\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    project_id\n    person_id\n    role_id\n    workstream_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n  }\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    person_id\n    note\n    leave_type\n    minutes_per_day\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n}\n\nfragment PersonAddProjectRow_user_3WSZHA on users {\n  ...AddProjectToPerson_user_3WSZHA\n}\n\nfragment PersonCustomEditor_person on people {\n  id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n}\n\nfragment PersonCustomEditor_viewer on users {\n  id\n  view {\n    id\n    name\n    people_filters\n  }\n  account {\n    id\n    use_week_numbers\n    custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      description\n      sort_order\n    }\n    custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      description\n      sort_order\n    }\n    custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      single_select\n      description\n      sort_order\n      options: custom_select_options {\n        id\n        name\n      }\n    }\n    custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      description\n      sort_order\n    }\n  }\n}\n\nfragment PersonCustomFieldTypes_accounts on accounts {\n  custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n  custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n  custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    singleSelect: single_select\n    model\n    required\n    options: custom_select_options {\n      id\n      name\n    }\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n  custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n}\n\nfragment PersonDetails_person_EEkLV on people {\n  ...PersonTimeOffRow_person_EEkLV\n  ...ProjectStatusRow_person\n  ...PersonAddProjectRow_person_EEkLV\n  ...Overbookings_person_EEkLV\n  id\n  first_name\n  last_name\n  email\n  image_key\n  is_placeholder\n  active\n  tags\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  archivable\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    is_template\n    note\n    role_id\n    workstream_id\n    person_id\n    project_id\n    phase_id\n    updated_at\n    non_working_day\n  }\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    person_id\n    note\n    leave_type\n    minutes_per_day\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    cost: cost_private\n    role {\n      id\n      name\n    }\n  }\n  people_notes {\n    id\n    note\n    created_at\n  }\n  team {\n    id\n    name\n  }\n  project_memberships {\n    id\n    person_id\n    project_id\n    role_id\n    workstream_id\n    workstream {\n      id\n      name\n    }\n  }\n  person_requests {\n    id\n    status\n    updated_at\n    user {\n      id\n      first_name\n      last_name\n      role_name\n    }\n    person {\n      id\n      first_name\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        minutes_per_day\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n  placeholder_suggestions {\n    suggested_person_id\n  }\n  ...EditPersonForm_person\n  ...PlaceholderProjectRow_placeholder\n}\n\nfragment PersonDetails_user_2UVESh on users {\n  account {\n    id\n    default_full_time_minutes\n    projects(where: $projectsFilter) {\n      id\n      name\n      confirmed\n      active\n      pricing_model\n      is_template\n      priority\n      emoji\n      phases {\n        id\n        name\n        color\n        start_date: start_date_runn\n        end_date: end_date_runn\n      }\n      client {\n        id\n        name\n        image_key\n        website\n      }\n      links {\n        id\n        name\n        href\n        show_in_planner\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        typeId: custom_checkbox_type_id\n        value\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      tags\n    }\n    roles {\n      id\n      name\n    }\n    workstreams {\n      id\n      name\n      archived\n    }\n    ...PlaceholderProjectRow_account\n    ...PersonTimeOffRow_account_2UVESh\n    ...PersonProjectRow_account\n  }\n}\n\nfragment PersonForm_viewer on users {\n  id\n  permissions\n  first_name\n  last_name\n  view {\n    id\n    name\n    people_filters\n  }\n  account {\n    id\n    default_full_time_minutes\n    currency\n    business_days\n    use_week_numbers\n    teams {\n      id\n      name\n    }\n    holidays_groups(order_by: {name: asc}) {\n      id\n      name\n    }\n    clients {\n      id\n      name\n    }\n    roles {\n      id\n      name\n      active\n      default_hour_cost: default_hour_cost_private\n    }\n    ...TeamSelector_account\n    ...CustomFieldSectionHeaderPerson_account\n  }\n  ...PersonCustomEditor_viewer\n}\n\nfragment PersonManagement_user_3aMKBZ on users {\n  favourite_people\n  account {\n    default_full_time_minutes\n    custom_select_types {\n      id\n      name\n      model\n      options: custom_select_options {\n        id\n        name\n      }\n    }\n    projects(where: $projectsFilter) {\n      ...PlaceholderCapacityIndicator_projects\n      id\n      name\n      active\n      confirmed\n      pricing_model\n      is_template\n      priority\n      emoji\n      client {\n        id\n        image_key\n        name\n        website\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        typeId: custom_checkbox_type_id\n        value\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      phases {\n        id\n        name\n        color\n        start_date: start_date_runn\n        end_date: end_date_runn\n      }\n      tags\n    }\n    teams {\n      id\n      name\n    }\n    people(where: $peopleFilter) {\n      ...PersonSummaryRow_person_EEkLV\n      ...PlaceholderSummaryRow_person_EEkLV\n      ...PersonDetails_person_EEkLV\n      id\n      is_placeholder\n      first_name\n      last_name\n      email\n      active\n      tags\n      created_at\n      image_key\n      archivable\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        employment_type\n        minutes_per_day\n        role_id\n        cost: cost_private\n        role {\n          id\n          name\n          active\n        }\n      }\n      time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        person_id\n        leave_type\n        minutes_per_day\n        ext_time_off_links(where: {active: {_eq: true}}) {\n          time_off_id\n          ext_time_off_id\n          active\n          external_id: ext_time_off_id\n          external: ext_time_off {\n            __typename\n            id\n            integration_id\n          }\n        }\n      }\n      team {\n        id\n        name\n      }\n      assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        project_id\n        person_id\n        role_id\n        phase_id\n        workstream_id\n        end_date: end_date_runn\n        start_date: start_date_runn\n        minutes_per_day\n        is_billable\n        is_template\n        note\n        non_working_day\n      }\n      references\n      competencies {\n        id\n        level\n        skill {\n          id\n          name\n        }\n      }\n      project_memberships {\n        id\n        project_id\n        person_id\n        role_id\n        workstream_id\n        is_placeholder\n        project {\n          id\n          name\n        }\n        workstream {\n          id\n          name\n        }\n      }\n      people_notes {\n        id\n        note\n        created_at\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        typeId: custom_checkbox_type_id\n        value\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      person_requests {\n        id\n        status\n        project_id\n        updated_at\n        user {\n          id\n          first_name\n          last_name\n          role_name\n        }\n        person {\n          id\n          first_name\n          contracts {\n            id\n            start_date: start_date_runn\n            end_date: end_date_runn\n            cost: cost_private\n            minutes_per_day\n            role {\n              id\n              name\n              active\n            }\n          }\n        }\n      }\n      placeholder_suggestions {\n        suggested_person_id\n      }\n      ...PersonCustomEditor_person\n    }\n  }\n}\n\nfragment PersonPlannerMenu_person on people {\n  id\n  project_memberships {\n    id\n    role_id\n    project_id\n    workstream_id\n    has_actuals\n  }\n  people_notes_aggregate {\n    aggregate {\n      count\n    }\n  }\n  ...ChangeProjectRoleModal_person\n  ...ChangeWorkstreamModal_person\n  ...PersonSidePanel_person\n}\n\nfragment PersonPlannerMenu_project on projects {\n  id\n  name\n  project_workstreams {\n    workstream_id\n  }\n  ...ChangeProjectRoleModal_project\n  ...RemoveMembershipFromProjectMenuItem_project\n  ...ChangeWorkstreamModal_project\n}\n\nfragment PersonPlannerMenu_user on users {\n  id\n  ...PersonSidePanel_user\n  ...EditPersonForm_user\n  account {\n    id\n    roles {\n      id\n      ...ChangeProjectRoleModal_roles\n    }\n  }\n}\n\nfragment PersonProjectRow_account on accounts {\n  secondary_person_field\n  custom_text_types_project: custom_text_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_date_types_project: custom_date_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_select_types_project: custom_select_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    options: custom_select_options {\n      id\n      name\n    }\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_checkbox_types_project: custom_checkbox_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  workstreams {\n    id\n    name\n    archived\n  }\n  ...PlannerCalendarRow_account\n  ...PlannerLeftColumn_account\n}\n\nfragment PersonRows_people_EEkLV on people {\n  id\n  first_name\n  last_name\n  is_placeholder\n  active\n  project_memberships {\n    id\n    role_id\n    workstream_id\n    project_id\n  }\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    project_id\n    role_id\n    person_id\n    workstream_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n  }\n  ...ProjectDetailsPersonRow_person_EEkLV\n}\n\nfragment PersonRows_project on projects {\n  id\n  members {\n    id\n    person_id\n    project_id\n    role_id\n    workstream_id\n    is_placeholder\n    person {\n      id\n      active\n    }\n  }\n  ...ProjectDetailsPersonRow_project\n}\n\nfragment PersonRows_user on users {\n  id\n  ...ProjectDetailsPersonRow_user\n  account {\n    id\n    ...ProjectDetailsPersonRow_account\n  }\n}\n\nfragment PersonSchedulePanel_user_1dOjVc on users {\n  favouritePersonIds: favourite_people\n  account {\n    people(where: $peopleFilter) {\n      id\n      is_placeholder\n      ...PersonSummaryRow_person_EEkLV\n      ...PersonDetails_person_EEkLV\n      ...PlaceholderSummaryRow_person_EEkLV\n    }\n  }\n}\n\nfragment PersonSelector_people on people {\n  id\n  email\n  first_name\n  last_name\n  image_key\n}\n\nfragment PersonSidePanelContract_account on accounts {\n  id\n  business_days\n}\n\nfragment PersonSidePanelContract_person on people {\n  id\n  contracts {\n    id\n    cost: cost_private\n    employment_type\n    job_title\n    minutes_per_day\n    rostered_days\n    start_date: start_date_runn\n    end_date: end_date_runn\n    role {\n      name\n      default_hour_cost: default_hour_cost_private\n    }\n  }\n}\n\nfragment PersonSidePanelDetails_account on accounts {\n  id\n  custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n  custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    options: custom_select_options {\n      id\n      name\n    }\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n  custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    description\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n  custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n}\n\nfragment PersonSidePanelDetails_person on people {\n  id\n  first_name\n  last_name\n  email\n  tags\n  references\n  holidays_group {\n    id\n    name\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  team {\n    id\n    name\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  links {\n    id\n    href\n    name\n    show_in_planner\n  }\n}\n\nfragment PersonSidePanelNotes_person on people {\n  id\n  email\n  is_placeholder\n  people_notes {\n    id\n    note\n    created_at\n    updated_at\n    creator_email\n    created_by\n    user_id\n  }\n}\n\nfragment PersonSidePanelNotes_user on users {\n  id\n}\n\nfragment PersonSidePanel_person on people {\n  id\n  first_name\n  last_name\n  email\n  image_key\n  team {\n    id\n    name\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    role {\n      id\n      name\n    }\n    job_title\n  }\n  people_notes_aggregate {\n    aggregate {\n      count\n    }\n  }\n  ...PersonSidePanelDetails_person\n  ...PersonCustomEditor_person\n  ...PersonActionButtons_person\n  ...EditPersonForm_person\n  ...PersonSidePanelContract_person\n  ...PersonSidePanelNotes_person\n}\n\nfragment PersonSidePanel_user on users {\n  id\n  favourite_people\n  account {\n    id\n    secondary_person_field\n    ...PersonSidePanelDetails_account\n    ...PersonSidePanelContract_account\n  }\n  ...PersonActionButtons_user\n  ...EditPersonForm_user\n  ...PersonSidePanelNotes_user\n}\n\nfragment PersonSummaryGraph_account on accounts {\n  ...CapacityIndicator_account\n}\n\nfragment PersonSummaryRow_person_EEkLV on people {\n  created_at\n  id\n  first_name\n  last_name\n  is_placeholder\n  email\n  image_key\n  archivable\n  tags\n  active\n  team_id\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    person_id\n    role_id\n    project_id\n    workstream_id\n    note\n    is_billable\n    is_template\n    phase_id\n    non_working_day\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    role {\n      id\n      name\n    }\n    job_title\n    rostered_days\n  }\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    person_id\n    leave_type\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n  team {\n    id\n    name\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  placeholder_suggestions {\n    suggested_person_id\n  }\n  person_requests {\n    id\n    status\n    updated_at\n    user {\n      id\n      first_name\n      last_name\n    }\n    person {\n      id\n      first_name\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        minutes_per_day\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n  people_notes {\n    id\n    note\n    created_at\n  }\n  ...EditPersonForm_person\n  ...PlannerLeftColumn_person\n  ...PlaceholderActionButtons_placeholder\n  ...PersonSidePanel_person\n  ...ContractsTooltip_person\n}\n\nfragment PersonSummaryRow_user_2UVESh on users {\n  id\n  ...PersonSidePanel_user\n  ...PlannerLeftColumn_user\n  account {\n    id\n    ...PersonSummaryGraph_account\n    ...PlannerLeftColumn_account\n    default_full_time_minutes\n    secondary_person_field\n    projects(where: $projectsFilter) {\n      id\n      confirmed\n      is_template\n    }\n    custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      show_in_planner\n      filterable_in_planner\n    }\n    custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      show_in_planner\n      filterable_in_planner\n    }\n    custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      options: custom_select_options {\n        id\n        name\n      }\n      show_in_planner\n      filterable_in_planner\n    }\n    custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      show_in_planner\n      filterable_in_planner\n    }\n    users {\n      id\n      email\n    }\n    invitations {\n      id\n      email\n    }\n  }\n}\n\nfragment PersonTagSelector_user on users {\n  id\n  account {\n    id\n    people_tags: tags(where: {model: {_eq: \"person\"}}) {\n      id\n      name\n      model\n      archived\n    }\n  }\n}\n\nfragment PersonTimeOffRow_account_2UVESh on accounts {\n  id\n  default_full_time_minutes\n  projects(where: $projectsFilter) {\n    id\n  }\n  ...DragToCreateOutline_account\n  ...TimeOffActionPill_account\n}\n\nfragment PersonTimeOffRow_person_EEkLV on people {\n  id\n  email\n  first_name\n  last_name\n  image_key\n  is_placeholder\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    person_id\n    note\n    leave_type\n    minutes_per_day\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    role {\n      id\n      name\n    }\n  }\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    person_id\n    role_id\n    project_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    phase_id\n    workstream_id\n    is_billable\n    is_template\n    note\n    non_working_day\n  }\n  holidays_group {\n    id\n    name\n  }\n}\n\nfragment PhaseItem_phase on phases {\n  id\n  name\n  start_date: start_date_runn\n  end_date: end_date_runn\n  color\n  project_id\n  revenue_budget: revenue_budget_private\n}\n\nfragment PhaseItem_project on projects {\n  id\n  budget_method\n  is_template\n}\n\nfragment PhasesWrapper_project on projects {\n  id\n  is_template\n  phases {\n    id\n    name\n    color\n    start_date: start_date_runn\n    end_date: end_date_runn\n    ...PhaseItem_phase\n  }\n  ...PhaseItem_project\n}\n\nfragment PhasesWrapper_user on users {\n  id\n  account {\n    id\n    rate_cards {\n      id\n      name\n      blended_rate: blended_rate_private\n      blended_rate_card\n      role_charge_out_rates {\n        role_id\n        charge_out_rate: charge_out_rate_private\n      }\n    }\n  }\n}\n\nfragment PlaceholderActionButtons_placeholder on people {\n  id\n  email\n  is_placeholder\n  active\n  archivable\n  first_name\n  last_name\n  tags\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  custom_date_values {\n    typeId: custom_date_type_id\n    value\n  }\n  people_notes {\n    id\n  }\n  person_requests {\n    id\n    status\n    updated_at\n    user {\n      id\n      first_name\n      last_name\n    }\n  }\n  team {\n    id\n    name\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    cost: cost_private\n    role {\n      id\n      name\n    }\n  }\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    person_id\n    leave_type\n    minutes_per_day\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  project_memberships {\n    id\n    project {\n      id\n      is_template\n    }\n    workstream_id\n  }\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    project_id\n    person_id\n    phase_id\n    role_id\n    workstream_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    is_billable\n    is_template\n    minutes_per_day\n    note\n    non_working_day\n  }\n  placeholder_suggestions {\n    suggested_person_id\n  }\n}\n\nfragment PlaceholderCapacityIndicator_projects on projects {\n  id\n  confirmed\n  is_template\n}\n\nfragment PlaceholderForm_user on users {\n  account {\n    id\n    roles {\n      id\n      name\n      active\n      default_hour_cost: default_hour_cost_private\n      contracts(where: {person: {is_placeholder: {_eq: true}}}, limit: 1, order_by: {created_at: desc}) {\n        person {\n          first_name\n          last_name\n          placeholder_count\n          created_at\n        }\n      }\n    }\n    real_active_people: people(where: {active: {_eq: true}, is_placeholder: {_eq: false}}, order_by: {first_name: asc, last_name: asc}) {\n      id\n      ...PersonSelector_people\n    }\n    ...TeamSelector_account\n    ...CustomFieldSectionHeaderPerson_account\n  }\n}\n\nfragment PlaceholderPlannerMenu_account on accounts {\n  id\n  ...PlaceholderSidePanel_account\n  ...PlaceholderWorkflowMenu_account\n  roles {\n    id\n    ...ChangeProjectRoleModal_roles\n  }\n}\n\nfragment PlaceholderPlannerMenu_placeholder on people {\n  id\n  project_memberships {\n    id\n    workstream {\n      id\n    }\n  }\n  first_name\n  last_name\n  ...PlaceholderWorkflowMenu_placeholder\n  ...ChangeWorkstreamModal_person\n  ...PlaceholderSidePanel_placeholder\n  ...ChangeProjectRoleModal_person\n}\n\nfragment PlaceholderPlannerMenu_project on projects {\n  id\n  name\n  is_template\n  project_workstreams {\n    workstream_id\n  }\n  ...ChangeWorkstreamModal_project\n  ...ChangeProjectRoleModal_project\n}\n\nfragment PlaceholderPlannerMenu_user on users {\n  id\n  ...PlaceholderSidePanel_user\n  ...PlaceholderWorkflowMenu_user\n}\n\nfragment PlaceholderProjectRow_account on accounts {\n  custom_text_types {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_date_types {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_select_types {\n    id\n    name\n    options: custom_select_options {\n      id\n      name\n    }\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_checkbox_types {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  ...PlannerCalendarRow_account\n}\n\nfragment PlaceholderProjectRow_placeholder on people {\n  id\n  active\n  project_memberships {\n    id\n    workstream {\n      id\n      name\n    }\n  }\n  ...PlannerLeftColumn_person\n}\n\nfragment PlaceholderSidePanel_account on accounts {\n  id\n  custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    options: custom_select_options {\n      id\n      name\n    }\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    description\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n}\n\nfragment PlaceholderSidePanel_placeholder on people {\n  id\n  is_placeholder\n  active\n  archivable\n  first_name\n  last_name\n  tags\n  project_memberships {\n    id\n    project {\n      id\n      is_template\n    }\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  people_notes {\n    id\n  }\n  person_requests {\n    id\n    status\n    updated_at\n    user {\n      id\n      first_name\n      last_name\n    }\n  }\n  team {\n    id\n    name\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    cost: cost_private\n    role {\n      id\n      name\n    }\n  }\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    person_id\n    leave_type\n    minutes_per_day\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    project_id\n    person_id\n    phase_id\n    role_id\n    workstream_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    is_billable\n    is_template\n    minutes_per_day\n    note\n    non_working_day\n  }\n  placeholder_suggestions {\n    suggested_person_id\n    suggested_person {\n      id\n      ...SuggestedPerson_person\n    }\n  }\n  ...PersonCustomEditor_person\n  ...PlaceholderActionButtons_placeholder\n  ...PersonSidePanelNotes_person\n}\n\nfragment PlaceholderSidePanel_user on users {\n  id\n  ...PersonSidePanelNotes_user\n}\n\nfragment PlaceholderSummaryRow_person_EEkLV on people {\n  id\n  is_placeholder\n  first_name\n  last_name\n  email\n  active\n  tags\n  image_key\n  archivable\n  team {\n    id\n    name\n  }\n  project_memberships {\n    id\n    workstream_id\n    project_id\n    workstream {\n      id\n      name\n    }\n  }\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    project_id\n    person_id\n    phase_id\n    role_id\n    workstream_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    is_billable\n    is_template\n    minutes_per_day\n    note\n    non_working_day\n  }\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    person_id\n    leave_type\n    minutes_per_day\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    cost: cost_private\n    role {\n      id\n      name\n    }\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  person_requests {\n    id\n    status\n    updated_at\n    user {\n      id\n      first_name\n      last_name\n    }\n    person {\n      id\n      first_name\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        minutes_per_day\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n  people_notes {\n    id\n    note\n    created_at\n  }\n  placeholder_suggestions {\n    suggested_person_id\n  }\n  ...PlaceholderSidePanel_placeholder\n  ...EditPersonForm_person\n  ...PersonCustomEditor_person\n  ...PersonDetails_person_EEkLV\n  ...PlannerLeftColumn_person\n  ...PlaceholderActionButtons_placeholder\n}\n\nfragment PlaceholderSummaryRow_user_2UVESh on users {\n  ...PlannerLeftColumn_user\n  ...PlaceholderSidePanel_user\n  id\n  favouritePersonIds: favourite_people\n  account {\n    ...PlaceholderSidePanel_account\n    ...PlannerLeftColumn_account\n    default_full_time_minutes\n    projects(where: $projectsFilter) {\n      ...PlaceholderCapacityIndicator_projects\n      id\n      confirmed\n      is_template\n      name\n      ...PlannerLeftColumn_project\n    }\n    custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      show_in_planner\n      filterable_in_planner\n    }\n    custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      show_in_planner\n    }\n    custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      options: custom_select_options {\n        id\n        name\n      }\n      show_in_planner\n      filterable_in_planner\n    }\n    custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      description\n      show_in_planner\n      filterable_in_planner\n    }\n  }\n}\n\nfragment PlaceholderWorkflowMenu_account on accounts {\n  id\n  ...PlaceholderSidePanel_account\n}\n\nfragment PlaceholderWorkflowMenu_placeholder on people {\n  id\n  ...PlaceholderSidePanel_placeholder\n}\n\nfragment PlaceholderWorkflowMenu_user on users {\n  id\n  ...PlaceholderSidePanel_user\n}\n\nfragment PlannerCalendarRow_account on accounts {\n  id\n  default_full_time_minutes\n  ...DragToCreateOutline_account\n  ...AssignmentActionPill_account\n}\n\nfragment PlannerDatePickerHourStats_account on accounts {\n  ...EffortInput_account\n  ...TotalEffortInput_account\n}\n\nfragment PlannerDatePicker_account on accounts {\n  id\n  default_full_time_minutes\n  ...MiniPicker_account\n  ...TimeOffMiniPicker_account\n  ...FullPicker_account\n}\n\nfragment PlannerHeader_account_2UVESh on accounts {\n  ...PageControls_account_2UVESh\n}\n\nfragment PlannerLeftColumn_account on accounts {\n  id\n  ...PlaceholderPlannerMenu_account\n  ...ViewExternalProjectLink_account\n}\n\nfragment PlannerLeftColumn_person on people {\n  id\n  email\n  is_placeholder\n  ...PlaceholderPlannerMenu_placeholder\n  ...PersonPlannerMenu_person\n}\n\nfragment PlannerLeftColumn_project on projects {\n  id\n  name\n  confirmed\n  is_template\n  created_at\n  calc_start_date\n  archivable\n  has_actuals\n  tags\n  active\n  priority\n  pricing_model\n  total_budget: total_budget_private\n  expenses_budget: expenses_budget_private\n  emoji\n  client {\n    id\n    name\n    image_key\n    website\n    real_client\n    internal\n  }\n  members {\n    id\n    person_id\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  future_assignments_aggregate: assignments_aggregate(where: {end_date_iso: {_gte: $todaysDate}}) {\n    aggregate {\n      count\n    }\n  }\n  ext_project_links(where: {active: {_eq: true}}) {\n    project_id\n    ext_project_id\n  }\n  notes_aggregate {\n    aggregate {\n      count\n    }\n  }\n  ...PersonPlannerMenu_project\n  ...PlaceholderPlannerMenu_project\n  ...ProjectLine_project\n  ...ProjectMilestones_project\n  ...EditProjectForm_project\n  ...CreateProjectFromTemplateForm_project\n  ...CreateTemplateFromProjectForm_project\n  ...ViewExternalProjectLink_project\n  ...ProjectSidePanel_project\n}\n\nfragment PlannerLeftColumn_user on users {\n  id\n  ...PersonSidePanel_user\n  ...PersonPlannerMenu_user\n  ...ProjectPlannerMenu_user\n  ...ProjectTemplatePlannerMenu_user\n  ...PlaceholderPlannerMenu_user\n}\n\nfragment ProjectAddPersonRow_account_3aMKBZ on accounts {\n  people(where: $peopleFilter) {\n    id\n    active\n    email\n    assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n      id\n      start_date: start_date_runn\n      end_date: end_date_runn\n      person_id\n      project_id\n      role_id\n      workstream_id\n    }\n  }\n  ...AddPersonToProject_account_1O2T5R\n}\n\nfragment ProjectAddPersonRow_project on projects {\n  id\n  name\n  is_template\n  members {\n    id\n    person_id\n    project_id\n    role_id\n    workstream_id\n    is_placeholder\n    person {\n      id\n      active\n    }\n  }\n  ...useExtProjectMembersList_project\n}\n\nfragment ProjectBudget_viewer on users {\n  id\n  permissions\n  account {\n    id\n    default_full_time_minutes\n    roles {\n      id\n      name\n      active\n    }\n    rate_cards {\n      id\n      name\n      blended_rate: blended_rate_private\n      blended_rate_card\n      role_charge_out_rates {\n        role_id\n        rate_card_id\n        charge_out_rate: charge_out_rate_private\n      }\n    }\n  }\n}\n\nfragment ProjectCustomEditor_project on projects {\n  id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n}\n\nfragment ProjectCustomEditor_viewer on users {\n  id\n  view {\n    id\n    name\n    project_filters\n  }\n  account {\n    id\n    use_week_numbers\n    custom_text_types_project: custom_text_types(where: {model: {_eq: \"PROJECT\"}}) {\n      id\n      name\n      description\n      sort_order\n    }\n    custom_date_types_project: custom_date_types(where: {model: {_eq: \"PROJECT\"}}) {\n      id\n      name\n      description\n      sort_order\n    }\n    custom_select_types_project: custom_select_types(where: {model: {_eq: \"PROJECT\"}}) {\n      id\n      name\n      single_select\n      description\n      sort_order\n      options: custom_select_options {\n        id\n        name\n      }\n    }\n    custom_checkbox_types_project: custom_checkbox_types(where: {model: {_eq: \"PROJECT\"}}) {\n      id\n      name\n      description\n      sort_order\n    }\n  }\n}\n\nfragment ProjectCustomFieldTypes_accounts on accounts {\n  custom_text_types_project: custom_text_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n  custom_date_types_project: custom_date_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n  custom_select_types_project: custom_select_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    model\n    required\n    singleSelect: single_select\n    options: custom_select_options {\n      id\n      name\n    }\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n  custom_checkbox_types_project: custom_checkbox_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n    sort_order\n  }\n}\n\nfragment ProjectDetailsDetectedPersonRow_account on accounts {\n  id\n  ...PlannerLeftColumn_account\n  ...PlannerCalendarRow_account\n}\n\nfragment ProjectDetailsDetectedPersonRow_extPerson on ext_person {\n  id\n  first_name\n  last_name\n  email\n  is_placeholder\n  active\n}\n\nfragment ProjectDetailsDetectedPersonRow_project on projects {\n  id\n  name\n  ...PlannerLeftColumn_project\n}\n\nfragment ProjectDetailsDetectedPersonRow_user on users {\n  id\n  ...PlannerLeftColumn_user\n}\n\nfragment ProjectDetailsPersonRow_account on accounts {\n  id\n  custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    options: custom_select_options {\n      id\n      name\n    }\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  users {\n    id\n    email\n  }\n  invitations {\n    id\n    email\n  }\n  ...PlannerCalendarRow_account\n  ...PlannerLeftColumn_account\n}\n\nfragment ProjectDetailsPersonRow_person_EEkLV on people {\n  ...Overbookings_person_EEkLV\n  ...EditPersonForm_person\n  id\n  first_name\n  last_name\n  image_key\n  is_placeholder\n  email\n  active\n  archivable\n  team {\n    id\n    name\n  }\n  tags\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    cost: cost_private\n    minutes_per_day\n    role {\n      id\n      name\n    }\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    is_template\n    note\n    role_id\n    person_id\n    phase_id\n    project_id\n    workstream_id\n    updated_at\n    non_working_day\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    person_id\n    leave_type\n    note\n    minutes_per_day\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  people_notes {\n    id\n    note\n    created_at\n  }\n  person_requests {\n    id\n    status\n    project_id\n    updated_at\n    user {\n      id\n      first_name\n      last_name\n    }\n    person {\n      id\n      first_name\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        minutes_per_day\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n  holidays_group {\n    id\n    name\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  placeholder_suggestions {\n    suggested_person_id\n  }\n  ...PersonCustomEditor_person\n  ...PlannerLeftColumn_person\n  ...PlaceholderActionButtons_placeholder\n  ...ContractsTooltip_person\n}\n\nfragment ProjectDetailsPersonRow_project on projects {\n  id\n  name\n  confirmed\n  pricing_model\n  is_template\n  emoji\n  client {\n    id\n    name\n    image_key\n    website\n  }\n  phases {\n    id\n    color\n    name\n    start_date: start_date_runn\n    end_date: end_date_runn\n  }\n  members {\n    id\n    workstream_id\n    role_id\n    person_id\n    role {\n      id\n      name\n    }\n    workstream {\n      id\n      name\n    }\n  }\n  ...PlannerLeftColumn_project\n}\n\nfragment ProjectDetailsPersonRow_user on users {\n  id\n  ...PlannerLeftColumn_user\n  ...PersonSidePanel_user\n}\n\nfragment ProjectDetailsSection_account_1dOjVc on accounts {\n  default_full_time_minutes\n  people(where: $peopleFilter) {\n    id\n    first_name\n    last_name\n    assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n      id\n      project_id\n      role_id\n      workstream_id\n      person_id\n      start_date: start_date_runn\n      end_date: end_date_runn\n    }\n  }\n  roles {\n    id\n    name\n  }\n  workstreams {\n    id\n    name\n    archived\n  }\n  ...ProjectDetails_account_1dOjVc\n}\n\nfragment ProjectDetailsSection_project on projects {\n  ...ProjectDetails_project\n  id\n  name\n  confirmed\n  pricing_model\n  members {\n    id\n    role_id\n    workstream_id\n    person_id\n    project_id\n    is_placeholder\n    person {\n      id\n      first_name\n      last_name\n      active\n    }\n  }\n  project_roles {\n    id\n    role_id\n  }\n  client {\n    id\n    name\n    image_key\n    website\n    account_id\n    account {\n      id\n      name\n    }\n  }\n}\n\nfragment ProjectDetailsSection_user on users {\n  id\n  ...ProjectDetails_user\n}\n\nfragment ProjectDetails_account_1dOjVc on accounts {\n  id\n  people(where: $peopleFilter) {\n    id\n    is_placeholder\n    first_name\n    last_name\n    ...PersonRows_people_EEkLV\n  }\n  ...ProjectGroupRow_account_1zMQSI\n}\n\nfragment ProjectDetails_project on projects {\n  id\n  name\n  ...PersonRows_project\n  ...ProjectGroupRow_project\n}\n\nfragment ProjectDetails_user on users {\n  id\n  ...PersonRows_user\n}\n\nfragment ProjectForm_viewer on users {\n  id\n  first_name\n  last_name\n  permissions\n  view {\n    id\n    name\n    project_filters\n  }\n  account {\n    id\n    billing_method\n    project_tags: tags(where: {model: {_eq: \"project\"}}) {\n      id\n      name\n      archived\n    }\n    projectTemplates: projects(where: {is_template: {_eq: true}}) {\n      id\n      ...TemplateSelector_project\n      ...TemplateNameUniqueInput_project\n    }\n    rate_cards {\n      id\n      name\n      active\n    }\n    clients {\n      id\n      active\n      name\n      image_key\n      website\n      internal\n      real_client\n    }\n    ext_projects {\n      id\n      name\n    }\n    teams {\n      id\n      name\n    }\n    workstreams {\n      id\n      name\n      archived\n    }\n    ...TeamSelector_account\n    ...CustomFieldSectionHeaderProject_account\n  }\n}\n\nfragment ProjectGroupList_account_3aMKBZ on accounts {\n  ...ProjectGroup_account_3aMKBZ\n}\n\nfragment ProjectGroupList_user on users {\n  id\n  ...ProjectGroup_user\n}\n\nfragment ProjectGroupMembersDisplay_account_1zMQSI on accounts {\n  id\n  ...AddPersonToProject_account_1O2T5R\n  people(where: $peopleFilter) {\n    id\n    email\n  }\n}\n\nfragment ProjectGroupMembersDisplay_project on projects {\n  id\n  name\n  members {\n    id\n    person_id\n  }\n  is_template\n  ext_project_links(where: {active: {_eq: true}}) {\n    project_id\n    ext_project_id\n  }\n  project_workstreams {\n    workstream_id\n  }\n}\n\nfragment ProjectGroupRow_account_1zMQSI on accounts {\n  id\n  ...ProjectGroupMembersDisplay_account_1zMQSI\n}\n\nfragment ProjectGroupRow_project on projects {\n  id\n  ...ProjectGroupMembersDisplay_project\n}\n\nfragment ProjectGroup_account_3aMKBZ on accounts {\n  ...ProjectRow_account_3aMKBZ\n}\n\nfragment ProjectGroup_user on users {\n  id\n  ...ProjectRow_user\n}\n\nfragment ProjectLine_project on projects {\n  id\n  confirmed\n  pricing_model\n  calc_start_date\n  calc_end_date\n}\n\nfragment ProjectManagement_user_1mdFGN on users {\n  ...ProjectTemplateGroup_user\n  ...ProjectGroupList_user\n  id\n  favourite_projects\n  account {\n    id\n    name\n    custom_select_types {\n      id\n      name\n      model\n      options: custom_select_options {\n        id\n        name\n      }\n    }\n    projects(where: $projectsFilter) {\n      id\n      priority\n      name\n      confirmed\n      is_template\n      tags\n      workstreams_computed\n      created_at\n      calc_start_date\n      calc_end_date\n      references\n      pricing_model_readable\n      active\n      team_id\n      has_actuals\n      team {\n        id\n        name\n      }\n      client {\n        id\n        name\n        active\n        image_key\n      }\n      members {\n        id\n        person_id\n        role_id\n        workstream_id\n      }\n      custom_select_values {\n        typeId: custom_select_type_id\n        optionId: custom_select_option_id\n      }\n      ...ProjectRowSummary_project_1veEkR\n      ...PhasesWrapper_project\n      ...ProjectDetailsSection_project\n      ...ProjectAddPersonRow_project\n      ...ProjectGroupRow_project\n      ...DetectedPeopleSection_project\n    }\n    ...ProjectGroupList_account_3aMKBZ\n    ...ProjectTemplateGroup_account_3aMKBZ\n  }\n}\n\nfragment ProjectMilestones_project on projects {\n  id\n  is_template\n  confirmed\n  pricing_model\n  milestones {\n    id\n    project_id\n    title\n    icon\n    date: date_runn\n    note\n  }\n}\n\nfragment ProjectPlannerList_user_4bzbde on users {\n  id\n  favourite_projects\n  account {\n    id\n    name\n    people(where: $peopleFilter) {\n      id\n      first_name\n      last_name\n      email\n      is_placeholder\n      tags\n      team {\n        id\n        name\n      }\n      project_memberships {\n        id\n        project_id\n      }\n      person_requests {\n        id\n        status\n      }\n      competencies {\n        id\n        level\n        skill {\n          id\n          name\n        }\n      }\n      current_contract {\n        id\n        job_title\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        value\n        custom_checkbox_type_id\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      managers {\n        id\n        user_id\n      }\n    }\n    projects(where: $projectsFilter) {\n      id\n      name\n      confirmed\n      pricing_model\n      tags\n      active\n      is_template\n      team {\n        id\n        name\n      }\n      client {\n        id\n        name\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        value\n        custom_checkbox_type_id\n      }\n      managers {\n        id\n        user_id\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      members {\n        id\n        person_id\n        role_id\n        workstream_id\n      }\n      project_workstreams {\n        workstream {\n          id\n        }\n      }\n    }\n  }\n  ...ProjectManagement_user_1mdFGN\n}\n\nfragment ProjectPlannerMenu_user on users {\n  id\n  ...ProjectSidePanel_user\n}\n\nfragment ProjectPlannerOptions_account on accounts {\n  id\n  workstreams {\n    id\n  }\n  project_custom_select_types: custom_select_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    model\n    single_select\n    options: custom_select_options {\n      id\n      name\n    }\n  }\n}\n\nfragment ProjectPlanner_account_2UVESh on accounts {\n  ...PlannerHeader_account_2UVESh\n}\n\nfragment ProjectRowSummary_account on accounts {\n  custom_text_types_project: custom_text_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_date_types_project: custom_date_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_select_types_project: custom_select_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    options: custom_select_options {\n      id\n      name\n    }\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_checkbox_types_project: custom_checkbox_types(where: {model: {_eq: \"PROJECT\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  ...PlannerLeftColumn_account\n}\n\nfragment ProjectRowSummary_project_1veEkR on projects {\n  id\n  name\n  confirmed\n  is_template\n  created_at\n  calc_start_date\n  archivable\n  has_actuals\n  tags\n  active\n  priority\n  pricing_model\n  total_budget: total_budget_private\n  expenses_budget: expenses_budget_private\n  emoji\n  client {\n    id\n    name\n    image_key\n    website\n    real_client\n    internal\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  future_assignments_aggregate: assignments_aggregate(where: {end_date_iso: {_gte: $todaysDate}}) {\n    aggregate {\n      count\n    }\n  }\n  ...PlannerLeftColumn_project\n  ...ProjectLine_project\n  ...ProjectMilestones_project\n  ...EditProjectForm_project\n  ...CreateProjectFromTemplateForm_project\n  ...CreateTemplateFromProjectForm_project\n  ...PhasesWrapper_project\n}\n\nfragment ProjectRowSummary_user on users {\n  id\n  ...PlannerLeftColumn_user\n}\n\nfragment ProjectRow_account_3aMKBZ on accounts {\n  id\n  ...ProjectRowSummary_account\n  ...ProjectAddPersonRow_account_3aMKBZ\n  ...ProjectDetailsSection_account_1dOjVc\n  ...ProjectGroupRow_account_1zMQSI\n  ...DetectedPeopleSection_account_1zMQSI\n}\n\nfragment ProjectRow_user on users {\n  id\n  ...ProjectDetailsSection_user\n  ...DetectedPeopleSection_user\n  ...ProjectRowSummary_user\n}\n\nfragment ProjectSchedulePanel_user_Mki9X on users {\n  ...ProjectDetailsSection_user\n  ...ProjectRowSummary_user\n  favouriteProjectIds: favourite_projects\n  userId: id\n  account {\n    ...ProjectRowSummary_account\n    ...ProjectAddPersonRow_account_3aMKBZ\n    ...ProjectDetailsSection_account_1dOjVc\n    ...AddPersonToProject_account_1O2T5R\n    projects(where: $projectsFilter) {\n      id\n      ...ProjectAddPersonRow_project\n      ...ProjectDetailsSection_project\n      ...ProjectRowSummary_project_1veEkR\n      ...PhasesWrapper_project\n    }\n  }\n}\n\nfragment ProjectSidePanelNotes_project on projects {\n  id\n  isTemplate: is_template\n  notes(order_by: {created_at: asc}) {\n    id\n    note\n    created_at\n    updated_at\n    creator_email\n    created_by\n    user_id\n  }\n}\n\nfragment ProjectSidePanelNotes_user on users {\n  id\n}\n\nfragment ProjectSidePanel_project on projects {\n  id\n  name\n  emoji\n  client {\n    image_key\n    website\n    name\n  }\n  notes_aggregate {\n    aggregate {\n      count\n    }\n  }\n  ...ProjectSidePanelNotes_project\n}\n\nfragment ProjectSidePanel_user on users {\n  id\n  ...ProjectSidePanelNotes_user\n}\n\nfragment ProjectStatusRow_person on people {\n  id\n  account {\n    id\n    default_full_time_minutes\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n  }\n}\n\nfragment ProjectTemplateGroup_account_3aMKBZ on accounts {\n  ...ProjectRow_account_3aMKBZ\n}\n\nfragment ProjectTemplateGroup_user on users {\n  id\n  ...ProjectRow_user\n}\n\nfragment ProjectTemplatePlannerMenu_user on users {\n  id\n  ...ProjectSidePanel_user\n}\n\nfragment RemoveMembershipFromProjectMenuItem_project on projects {\n  id\n  name\n  members {\n    id\n    project_id\n    person_id\n    workstream_id\n    role_id\n  }\n}\n\nfragment RoleForm_viewer on users {\n  account {\n    currency\n    id\n    rate_type\n    all_roles: roles {\n      id\n      name\n      active\n      default_hour_cost: default_hour_cost_private\n    }\n  }\n  permissions\n}\n\nfragment RoleSelector_user on users {\n  account {\n    id\n    roles {\n      id\n      name\n      active\n      default_hour_cost: default_hour_cost_private\n    }\n  }\n}\n\nfragment SelectPersonList_account_3aMKBZ on accounts {\n  id\n  people(where: $peopleFilter) {\n    id\n    first_name\n    last_name\n    email\n    active\n    image_key\n    is_placeholder\n    tags\n    team_id\n    contracts {\n      id\n      role_id\n      start_date: start_date_runn\n      end_date: end_date_runn\n      minutes_per_day\n      employment_type\n      job_title\n      role {\n        id\n        name\n      }\n    }\n    team {\n      id\n      name\n    }\n    time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n      id\n      person_id\n      start_date: start_date_runn\n      end_date: end_date_runn\n      ext_time_off_links(where: {active: {_eq: true}}) {\n        time_off_id\n        ext_time_off_id\n        active\n        external_id: ext_time_off_id\n        external: ext_time_off {\n          __typename\n          id\n          integration_id\n        }\n      }\n    }\n    assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n      id\n      person_id\n      project_id\n      role_id\n      phase_id\n      workstream_id\n      start_date: start_date_runn\n      end_date: end_date_runn\n      minutes_per_day\n      is_billable\n    }\n    competencies {\n      id\n      level\n      skill {\n        id\n        name\n      }\n    }\n    custom_select_values {\n      id\n      custom_select_option_id\n      custom_select_type_id\n      optionId: custom_select_option_id\n      typeId: custom_select_type_id\n    }\n    custom_text_values {\n      id\n      value\n      custom_text_type_id\n      typeId: custom_text_type_id\n    }\n    custom_checkbox_values {\n      id\n      value\n      custom_checkbox_type_id\n      typeId: custom_checkbox_type_id\n    }\n    custom_date_values {\n      id\n      value\n      custom_date_type_id\n      typeId: custom_date_type_id\n    }\n    project_memberships {\n      id\n      project_id\n      is_placeholder\n      workstream_id\n      role_id\n    }\n    managers {\n      id\n      user_id\n    }\n    ...ContractsTooltip_person\n  }\n  roles {\n    id\n    name\n    active\n    default_hour_cost: default_hour_cost_private\n  }\n  projects(where: $projectsFilter) {\n    id\n    name\n    confirmed\n    is_template\n    active\n    tags\n    client {\n      id\n      name\n    }\n    team {\n      id\n      name\n    }\n    members {\n      id\n      person_id\n      role_id\n      project_id\n      workstream_id\n      is_placeholder\n    }\n    custom_select_values {\n      id\n      custom_select_option_id\n      custom_select_type_id\n    }\n    custom_text_values {\n      id\n      value\n      custom_text_type_id\n    }\n    custom_checkbox_values {\n      id\n      value\n      custom_checkbox_type_id\n    }\n    custom_date_values {\n      id\n      value\n      custom_date_type_id\n    }\n    managers {\n      id\n      user_id\n    }\n  }\n  custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    options: custom_select_options {\n      id\n      name\n    }\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n  custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n    id\n    name\n    show_in_planner\n    filterable_in_planner\n  }\n}\n\nfragment SelectPersonList_user on users {\n  id\n  favourite_people\n  ...PersonSidePanel_user\n}\n\nfragment SelectViewDialog_user on users {\n  id\n  viewed_welcome\n}\n\nfragment ServerFlagsProvider_gql on query_root {\n  features {\n    id\n    enabled\n    description\n    name\n  }\n  features_accounts {\n    id\n    feature_id\n    enabled\n  }\n}\n\nfragment SingleExternalProjectMemberForm_viewer_1zMQSI on users {\n  account {\n    id\n    people(where: $peopleFilter) {\n      id\n      email\n      first_name\n      last_name\n      active\n      is_placeholder\n      current_contract {\n        id\n        role {\n          id\n          name\n        }\n      }\n    }\n    roles {\n      id\n      name\n    }\n  }\n}\n\nfragment SkillsSelector_viewer on users {\n  permissions\n  account {\n    id\n    allSkills: skills {\n      id\n      name\n    }\n  }\n}\n\nfragment SplitScreenMain_user on users {\n  ...SplitScreenRow_user\n  id\n  account {\n    id\n    custom_select_types {\n      id\n      name\n    }\n  }\n}\n\nfragment SplitScreenPanel_user_3aMKBZ on users {\n  ...SplitScreenMain_user\n  favourite_people\n  account {\n    default_full_time_minutes\n    projects(where: $projectsFilter) {\n      ...PlaceholderCapacityIndicator_projects\n      id\n      name\n      active\n      confirmed\n      is_template\n      client {\n        id\n        name\n      }\n      team {\n        id\n        name\n      }\n      tags\n      members {\n        id\n        person_id\n        role_id\n        project_id\n        workstream_id\n        is_placeholder\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        value\n        custom_checkbox_type_id\n      }\n      managers {\n        id\n        user_id\n      }\n    }\n    people(where: $peopleFilter) {\n      ...SplitScreenRow_person_EEkLV\n      id\n      first_name\n      last_name\n      email\n      tags\n      references\n      image_key\n      is_placeholder\n      active\n      team {\n        name\n        id\n      }\n      time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        person_id\n        leave_type\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n        ext_time_off_links(where: {active: {_eq: true}}) {\n          time_off_id\n          ext_time_off_id\n          active\n          external_id: ext_time_off_id\n          external: ext_time_off {\n            __typename\n            id\n            integration_id\n          }\n        }\n      }\n      assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n        is_billable\n        project_id\n        person_id\n        role_id\n        non_working_day\n        note\n        phase_id\n      }\n      contracts {\n        id\n        rostered_days\n        employment_type\n        minutes_per_day\n        cost: cost_private\n        start_date: start_date_runn\n        end_date: end_date_runn\n        job_title\n        role {\n          id\n          name\n        }\n      }\n      competencies {\n        id\n        level\n        skill {\n          id\n          name\n        }\n      }\n      custom_select_values {\n        id\n        custom_select_option_id\n        custom_select_type_id\n      }\n      custom_text_values {\n        id\n        value\n        custom_text_type_id\n      }\n      custom_checkbox_values {\n        id\n        value\n        custom_checkbox_type_id\n      }\n      custom_date_values {\n        id\n        value\n        custom_date_type_id\n      }\n      managers {\n        id\n        user_id\n      }\n    }\n  }\n}\n\nfragment SplitScreenRole_user on users {\n  account {\n    roles {\n      id\n      active\n      name\n    }\n  }\n}\n\nfragment SplitScreenRow_person_EEkLV on people {\n  ...PersonSummaryRow_person_EEkLV\n  ...PersonDetails_person_EEkLV\n  ...PlaceholderSidePanel_placeholder\n  ...PersonSidePanel_person\n  id\n  first_name\n  last_name\n  email\n  tags\n  references\n  image_key\n  is_placeholder\n  time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    person_id\n    leave_type\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    ext_time_off_links(where: {active: {_eq: true}}) {\n      time_off_id\n      ext_time_off_id\n      active\n      external_id: ext_time_off_id\n      external: ext_time_off {\n        __typename\n        id\n        integration_id\n      }\n    }\n  }\n  assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    is_template\n    project_id\n    person_id\n    role_id\n    workstream_id\n    non_working_day\n    note\n    phase_id\n  }\n  contracts {\n    id\n    rostered_days\n    employment_type\n    minutes_per_day\n    cost: cost_private\n    start_date: start_date_runn\n    end_date: end_date_runn\n    role {\n      id\n      name\n    }\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n  person_requests {\n    id\n    status\n  }\n  project_memberships {\n    id\n    project {\n      id\n      name\n      is_template\n    }\n  }\n}\n\nfragment SplitScreenRow_user on users {\n  ...PersonSidePanel_user\n  ...PlaceholderSidePanel_user\n  id\n  account {\n    id\n    default_full_time_minutes\n    roles {\n      id\n      name\n    }\n    custom_text_types_person: custom_text_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      show_in_planner\n      filterable_in_planner\n    }\n    custom_date_types_person: custom_date_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      show_in_planner\n      filterable_in_planner\n    }\n    custom_select_types_person: custom_select_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      options: custom_select_options {\n        id\n        name\n      }\n      show_in_planner\n      filterable_in_planner\n    }\n    custom_checkbox_types_person: custom_checkbox_types(where: {model: {_eq: \"PERSON\"}}) {\n      id\n      name\n      show_in_planner\n      filterable_in_planner\n    }\n    ...PersonSummaryGraph_account\n    ...PlaceholderSidePanel_account\n  }\n}\n\nfragment SuggestedPerson_person on people {\n  first_name\n  last_name\n  image_key\n}\n\nfragment SuperSearchConfig_user on users {\n  id\n  first_name\n  last_name\n  image_key\n  email\n  permissions\n  people(limit: 1) {\n    id\n    first_name\n    last_name\n    email\n    image_key\n    active\n  }\n  account {\n    id\n    ...ProjectCustomFieldTypes_accounts\n    ...PersonCustomFieldTypes_accounts\n  }\n}\n\nfragment SuperSearch_user_3WSZHA on users {\n  account {\n    id\n    projects(where: $projectsFilter) {\n      id\n      name\n      confirmed\n      active\n    }\n    ...useClients_account\n    ...usePeople_account_1zMQSI\n    ...useProjects_account_2UVESh\n    ...useProjectTemplates_account_2UVESh\n    ...useRoles_account\n    ...useSkills_account\n    ...useTags_account\n    ...useTeams_account\n    ...useCustomSelect_account\n    ...useWorkstreams_account\n    ...useManagers_account\n    ...TentativeProjectsToggle_account_2UVESh\n  }\n  ...ViewsDropdown_user_3WSZHA\n}\n\nfragment TeamSelector_account on accounts {\n  teams {\n    id\n    name\n  }\n}\n\nfragment TemplateNameUniqueInput_project on projects {\n  id\n  name\n}\n\nfragment TemplateSelector_project on projects {\n  id\n  name\n  tags\n  workstreams_computed\n  active\n  pricing_model\n  client_id\n  rate_card_id\n  team_id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  custom_date_values {\n    typeId: custom_date_type_id\n    value\n  }\n  members {\n    id\n    person_id\n  }\n  ...ProjectCustomEditor_project\n}\n\nfragment TentativeProjectsToggle_account_2UVESh on accounts {\n  projects(where: $projectsFilter) {\n    id\n    name\n    confirmed\n    active\n  }\n}\n\nfragment TimeOffActionPill_account on accounts {\n  id\n  ...PlannerDatePicker_account\n  projects(where: $projectsFilter) {\n    id\n    confirmed\n  }\n}\n\nfragment TimeOffEffortInputs_account on accounts {\n  id\n  ...EffortInput_account\n  ...TotalEffortInput_account\n}\n\nfragment TimeOffMiniPicker_account on accounts {\n  id\n  default_full_time_minutes\n  ...EffortInput_account\n  ...TotalEffortInput_account\n  ...TimeOffEffortInputs_account\n}\n\nfragment TimeOffSummaryAddRow_account on accounts {\n  ...AddTimeOffModal_account\n}\n\nfragment TimeOffSummaryCounter_account_1dOjVc on accounts {\n  people(where: $peopleFilter) {\n    id\n    time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n      id\n      start_date: start_date_runn\n      end_date: end_date_runn\n    }\n  }\n}\n\nfragment TimeOffSummaryPersonRow_account on accounts {\n  id\n  ...TimeOffActionPill_account\n  ...DragToCreateOutline_account\n}\n\nfragment TimeOffSummary_account_1dOjVc on accounts {\n  id\n  default_full_time_minutes\n  people(where: $peopleFilter) {\n    id\n    email\n    first_name\n    last_name\n    is_placeholder\n    active\n    tags\n    image_key\n    archivable\n    placeholder_suggestions {\n      suggested_person_id\n    }\n    contracts {\n      id\n      start_date: start_date_runn\n      end_date: end_date_runn\n      minutes_per_day\n      role {\n        id\n        name\n      }\n    }\n    time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n      id\n      start_date: start_date_runn\n      end_date: end_date_runn\n      person_id\n      note\n      leave_type\n      minutes_per_day\n      ext_time_off_links(where: {active: {_eq: true}}) {\n        time_off_id\n        ext_time_off_id\n        active\n        external_id: ext_time_off_id\n        external: ext_time_off {\n          __typename\n          id\n          integration_id\n        }\n      }\n    }\n    assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n      id\n      is_billable\n      is_template\n      minutes_per_day\n      start_date: start_date_runn\n      end_date: end_date_runn\n      person_id\n      role_id\n      project_id\n      phase_id\n      workstream_id\n      note\n      non_working_day\n    }\n    team {\n      id\n      name\n    }\n    competencies {\n      id\n      level\n      skill {\n        id\n        name\n      }\n    }\n  }\n  ...TimeOffSummaryPersonRow_account\n  ...TimeOffSummaryAddRow_account\n}\n\nfragment Timeline_user on users {\n  id\n  account {\n    id\n    default_full_time_minutes\n    use_week_numbers\n  }\n}\n\nfragment TotalEffortInput_account on accounts {\n  default_full_time_minutes\n}\n\nfragment User_Account_Integrations on users {\n  account {\n    id\n    ...Account_Integrations\n  }\n}\n\nfragment ViewExternalProjectLink_account on accounts {\n  id\n  ...Account_Integrations\n}\n\nfragment ViewExternalProjectLink_project on projects {\n  id\n  ...ExtLinks_Project\n}\n\nfragment ViewFieldsTooltip_user_3WSZHA on users {\n  id\n  ...ViewFilterValues_user_3WSZHA\n}\n\nfragment ViewFilterValues_user_3WSZHA on users {\n  id\n  account {\n    id\n    ...useClients_account\n    ...usePeople_account_1zMQSI\n    ...useProjects_account_2UVESh\n    ...useProjectTemplates_account_2UVESh\n    ...useRoles_account\n    ...useSkills_account\n    ...useTags_account\n    ...useTeams_account\n    ...useCustomSelect_account\n    ...useManagers_account\n  }\n}\n\nfragment ViewFormDialog_user_3WSZHA on users {\n  id\n  account {\n    id\n    user_accounts {\n      id\n      user {\n        id\n        first_name\n        last_name\n        email\n        image_key\n        permissions\n      }\n    }\n  }\n  ...ViewFilterValues_user_3WSZHA\n}\n\nfragment ViewsDropdown_user_3WSZHA on users {\n  id\n  ...ViewFormDialog_user_3WSZHA\n}\n\nfragment WelcomeVideoDialog_user on users {\n  id\n  first_name\n  account {\n    id\n    name\n  }\n}\n\nfragment useClients_account on accounts {\n  clients {\n    id\n    name\n    active\n    real_client\n  }\n}\n\nfragment useCustomSelect_account on accounts {\n  custom_select_types {\n    id\n    name\n    model\n    custom_select_options {\n      id\n      name\n    }\n  }\n}\n\nfragment useExtProjectMembersList_project on projects {\n  id\n  members {\n    id\n    person_id\n  }\n  ext_project_links(where: {active: {_eq: true}}) {\n    project_id\n    ext_project_id\n    ext_project {\n      id\n      ext_project_members(where: {deleted: {_eq: false}}) {\n        id\n        ext_person {\n          id\n          first_name\n          last_name\n          email\n          is_placeholder\n          active\n          ext_person_links(where: {active: {_eq: true}}) {\n            ext_person_id\n            person_id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useManagers_account on accounts {\n  id\n  user_accounts {\n    id\n    permissions\n    user {\n      id\n      first_name\n      last_name\n      permissions\n    }\n  }\n}\n\nfragment usePeople_account_1zMQSI on accounts {\n  people(where: $peopleFilter) {\n    id\n    first_name\n    last_name\n    is_placeholder\n    active\n  }\n}\n\nfragment useProjectTemplates_account_2UVESh on accounts {\n  projects(where: $projectsFilter) {\n    id\n    name\n    is_template\n  }\n}\n\nfragment useProjects_account_2UVESh on accounts {\n  projects(where: $projectsFilter) {\n    id\n    name\n    active\n    confirmed\n    is_template\n  }\n}\n\nfragment useRoles_account on accounts {\n  roles {\n    id\n    name\n    active\n  }\n}\n\nfragment useSkills_account on accounts {\n  skills {\n    id\n    name\n  }\n}\n\nfragment useTags_account on accounts {\n  tags {\n    id\n    name\n    model\n    archived\n  }\n}\n\nfragment useTeams_account on accounts {\n  teams {\n    id\n    name\n  }\n}\n\nfragment useWorkstreams_account on accounts {\n  workstreams {\n    id\n    name\n    archived\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3c1e665ff66de2661554fba224f0bda";

export default node;
